import {
  ClockCircleOutlined,
  DesktopOutlined,
  DisconnectOutlined,
  LinkOutlined,
  LockOutlined,
  PartitionOutlined,
  PlusCircleOutlined,
  FormatPainterFilled,
  ExclamationCircleOutlined,
  HistoryOutlined,
  MoreOutlined,
  CloseOutlined,
  CaretDownOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { MdOutlineSettingsRemote } from "react-icons/md";

import {
  Button,
  Card,
  Checkbox,
  Collapse,
  Dropdown,
  Grid,
  Menu,
  message,
  Modal,
  Pagination,
  Popconfirm,
  Select,
  Space,
  Table,
  Tag,
  Tooltip,
  Slider,
  Popover,
  Row,
  Col,
  InputNumber,
  Badge,
} from "antd";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import ButtonGroup from "../../components/views/ButtonGroup";
import firebase from "../../Firebase.js";
import PermissionManager from "../../managers/PermissionManager";
import PopupManager from "../../managers/PopupManager";
import ActionButton from "../ActionButton";
import CampaignSelector from "../CampaignSelector";
import ScreenEventPlaylistModule from "../ScreenEventPlaylistModule";
import AbstractTableView from "./AbstractTableView";
import ScreenIconView from "./ScreenIconView";
import "./ScreenTableView.css";
import {
  CHECK_LICENSE,
  USE_CAMPAIGN_SYNC,
  PLAYER_DOWNLOAD_URL,
} from "../../Config.js";
import { THEME_PALLETE } from "../../Theme.js";
import { Link } from "react-router-dom";
import Constants from "../../data/constants.js";
import ScreenPublishingHistoryView from "./ScreenPublishingHistoryView.js";
import PrimaryActionButton from "../PrimaryActionButton";
import {
  MonitorPlay,
  ArrowLeft,
  Wifi,
  Monitor,
  Info,
  Cpu,
  KeyRound,
  ShieldCheck,
  ShieldOff,
  RefreshCw,
  Send,
  ArrowUp,
  ArrowDown,
  Layers,
  Copy,
  Search,
  Globe,
  LayoutTemplate,
  Download,
  Eye,
  Sun,
} from "lucide-react";
import EmptyState from "../EmptyState";
import { motion, AnimatePresence } from "framer-motion";
import Animations from "../../animations/Animations";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";
const { Panel } = Collapse;
const { Column, ColumnGroup } = Table;
const { confirm } = Modal;
var db;

const TIMEZONE_OPTIONS = [
  { value: "Pacific/Honolulu", label: "(GMT-10:00) Hawaii" },
  { value: "America/Anchorage", label: "(GMT-09:00) Alaska" },
  { value: "America/Los_Angeles", label: "(GMT-08:00) Pacific Time" },
  { value: "America/Denver", label: "(GMT-07:00) Mountain Time" },
  { value: "America/Chicago", label: "(GMT-06:00) Central Time" },
  { value: "America/New_York", label: "(GMT-05:00) Eastern Time" },
  { value: "America/Sao_Paulo", label: "(GMT-03:00) São Paulo" },
  { value: "Europe/London", label: "(GMT+00:00) London" },
  { value: "Europe/Paris", label: "(GMT+01:00) Paris / Berlin" },
  { value: "Europe/Istanbul", label: "(GMT+03:00) Istanbul" },
  { value: "Asia/Dubai", label: "(GMT+04:00) Dubai" },
  { value: "Asia/Kolkata", label: "(GMT+05:30) India" },
  { value: "Asia/Bangkok", label: "(GMT+07:00) Bangkok" },
  { value: "Asia/Singapore", label: "(GMT+08:00) Singapore" },
  { value: "Asia/Tokyo", label: "(GMT+09:00) Tokyo" },
  { value: "Australia/Sydney", label: "(GMT+11:00) Sydney" },
  { value: "Pacific/Auckland", label: "(GMT+12:00) Auckland" },
];

const SCREEN_RATIOS = [
  { label: "16:9", value: "16/9", description: "Landscape TV" },
  { label: "9:16", value: "9/16", description: "Portrait" },
  { label: "4:3", value: "4/3", description: "Classic" },
  { label: "1:1", value: "1/1", description: "Square" },
];

const OS_ANDROID_PATH =
  "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zm-2.5-1c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5S2 7.67 2 8.5v7c0 .83.67 1.5 1.5 1.5zm17 0c.83 0 1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5S19 7.67 19 8.5v7c0 .83.67 1.5 1.5 1.5zM15.53 2.16l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z";

const OS_WINDOWS_PATH =
  "M0 3.449L9.75 2.1v9.451H0m10.949-9.602L24 0v11.4H10.949M0 12.6h9.75v9.451L0 20.699M10.949 12.6H24V24l-13.051-1.801";

/**
 * Renders an OS-specific brand glyph (Android robot / Windows logo) based on the
 * device `os` string, falling back to a neutral monitor for unknown platforms.
 */
const OsIcon = ({ os = "", size = 16 }) => {
  const key = String(os).toLowerCase();
  if (key.includes("win")) {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="#0078d4"
        style={{ flexShrink: 0 }}
      >
        <path d={OS_WINDOWS_PATH} />
      </svg>
    );
  }
  if (key.includes("android")) {
    return (
      <svg
        width={size}
        height={Math.round(size * 1.1)}
        viewBox="0 0 24 24"
        fill="#3ddc84"
        style={{ flexShrink: 0 }}
      >
        <path d={OS_ANDROID_PATH} />
      </svg>
    );
  }
  return <Monitor size={size - 2} color="#94a3b8" style={{ flexShrink: 0 }} />;
};

const ScreenTableView = ({
  parentProps = {},
  data,
  eventData = [],
  eventTypesData = [],
  onRowClicked = () => {},
  onRemoteAction = () => {},
  onScreenClicked = () => {},
  onCampaignClicked = () => {},
  onNeedsReload = () => {},
  onDelete = () => {},
  onEdit = () => {},
  onEditBrightness = () => {},
  onDuplicate = () => {},
  onPublish = () => {},
  onPairScreen = () => {},
  onPairNewScreen = () => {},
  onNeedsUnpair = () => {},
  onPreviewContent = () => {},
  onEditContent = null,
  selectedScreen: selectedScreenProp = undefined,
  onSelectScreen = null,
  onLocationChange = () => {},
}) => {
  const { lang } = useProLanguage();
  const t = (PRO_TRANSLATIONS[lang] || PRO_TRANSLATIONS.en).screen;

  const [screensStatus, setScreensStatus] = useState({});
  const [updatedEventData, setUpdatedEventData] = useState();
  const [formatPopoverVisible, setFormatPopoverVisible] = useState(null); // store screenCode of open popover
  const [formatValues, setFormatValues] = useState({}); // store value per screen
  const [tempFormatValues, setTempFormatValues] = useState({});
  const [saturationModalScreen, setSaturationModalScreen] = useState(null); // screen record for saturation modal
  const [popoverInitialFormatValue, setPopoverInitialFormatValue] = useState(
    {},
  );
  const [publishingHistoryVisible, setPublishingHistoryVisible] =
    useState(false);
  const [publishingHistoryScreenData, setPublishingHistoryScreenData] =
    useState(null);
  const [remoteControlOpen, setRemoteControlOpen] = useState(false); // detail-view remote control popover
  const [campaignPopoverVisible, setCampaignPopoverVisible] = useState(null); // ScreenCode of open campaign popover
  const [selectedScreenLocal, setSelectedScreenLocal] = useState(null);
  const isControlled = onSelectScreen !== null;
  const selectedScreen = isControlled
    ? (selectedScreenProp ?? null)
    : selectedScreenLocal;
  const setSelectedScreen = (value) => {
    if (!isControlled) setSelectedScreenLocal(value);
    if (onSelectScreen) onSelectScreen(value);
  };

  // Screen Preview ratio / resolution selection (detail view)
  const [previewResolutionMode, setPreviewResolutionMode] = useState("preset"); // "preset" | "custom"
  const [previewSelectedRatio, setPreviewSelectedRatio] = useState(
    SCREEN_RATIOS[0],
  );
  const [previewCustomWidth, setPreviewCustomWidth] = useState(1920);
  const [previewCustomHeight, setPreviewCustomHeight] = useState(1080);

  // Sync preview resolution defaults from the selected screen
  useEffect(() => {
    if (!selectedScreen) return;
    const w = Number(selectedScreen.ScreenWidth) || 1920;
    const h = Number(selectedScreen.ScreenHeight) || 1080;
    setPreviewCustomWidth(w);
    setPreviewCustomHeight(h);
    // Pick the preset ratio closest to the screen's native aspect ratio
    const nativeAspect = w / h;
    let closest = SCREEN_RATIOS[0];
    let smallestDiff = Infinity;
    SCREEN_RATIOS.forEach((r) => {
      const [rw, rh] = r.value.split("/").map(Number);
      const diff = Math.abs(rw / rh - nativeAspect);
      if (diff < smallestDiff) {
        smallestDiff = diff;
        closest = r;
      }
    });
    setPreviewSelectedRatio(closest);
  }, [selectedScreen?.ScreenID]);

  const renderNoScreensState = () => {
    const canPair = PermissionManager.checkPermission(
      PermissionManager.PERMISSION_KEY_SCREEN,
      PermissionManager.PERMISSION_TYPE_CREATE,
    );
    return (
      <EmptyState
        icon={<MonitorPlay size={28} color="#6366f1" />}
        title={t.noScreensTitle}
        description={t.noScreensDesc}
        action={
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: 12,
            }}
          >
            {canPair && (
              <Button
                type="primary"
                size="large"
                icon={<PlusCircleOutlined />}
                onClick={() => onPairNewScreen()}
                style={{
                  borderRadius: 10,
                  fontWeight: 600,
                  height: 44,
                  paddingLeft: 22,
                  paddingRight: 22,
                }}
              >
                {t.noScreensPairBtn || t.pairNewScreen}
              </Button>
            )}
          </div>
        }
      />
    );
  };

  const handleTimezoneChange = async (value, record) => {
    if (!firebase || !firebase.database) {
      message.warning("Firebase is not initialized.");
      return;
    }
    const {
      AccountCode = "",
      BrandCode = "",
      BranchCode = "",
      ScreenCode = "",
    } = record;
    if (!AccountCode || !ScreenCode) return;
    try {
      const dbRef = firebase
        .database()
        .ref()
        .child(`${AccountCode}/${BrandCode}/${BranchCode}/${ScreenCode}`);
      await dbRef.child("timezone").set(value);
      message.success(
        t.timezoneUpdated
          ? t.timezoneUpdated(value)
          : `Timezone updated to ${value}`,
      );
    } catch (err) {
      console.error("Timezone update error:", err);
      message.error("Failed to update timezone.");
    }
  };
  const [sortBy, setSortBy] = useState(null);
  const [sortDir, setSortDir] = useState("asc");
  const [localSearch, setLocalSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [locationFilter, setLocationFilter] = useState("all");
  const [selectedTableRows, setSelectedTableRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const PAGE_SIZE = 10;
  const [viewMode, setViewMode] = useState("list"); // "list" | "grid"
  const [openPopoverCode, setOpenPopoverCode] = useState(null);
  const [openDisplayCode, setOpenDisplayCode] = useState(null);
  const [openActionGroup, setOpenActionGroup] = useState(null); // "display" | "others" | null
  const [displayPlacement, setDisplayPlacement] = useState("bottomRight");
  const [displayMaxHeight, setDisplayMaxHeight] = useState("calc(80vh - 32px)");
  const [actionPlacement, setActionPlacement] = useState("bottomRight");
  const [actionMaxHeight, setActionMaxHeight] = useState("calc(80vh - 32px)");

  const computeActionPlacement = (el) => {
    const rect = el.getBoundingClientRect();
    const MARGIN = 16;
    const headerEl = document.querySelector(".ant-layout-header, header, nav");
    const headerHeight = headerEl
      ? headerEl.getBoundingClientRect().bottom
      : 64;
    const spaceBelow = window.innerHeight - rect.bottom - MARGIN;
    const spaceAbove = rect.top - headerHeight - MARGIN;
    if (spaceBelow >= spaceAbove) {
      setActionPlacement("bottomRight");
      setActionMaxHeight(`${Math.max(spaceBelow, 120)}px`);
    } else {
      setActionPlacement("topRight");
      setActionMaxHeight(`${Math.max(spaceAbove, 120)}px`);
    }
  };

  const toggleFormatPopover = (screenCode) => {
    if (formatPopoverVisible === screenCode) {
      // closing popover without saving â†’ revert temp value
      setTempFormatValues((prev) => ({
        ...prev,
        [screenCode]: formatValues[screenCode] ?? 1,
      }));
      setFormatPopoverVisible(null);
    } else {
      // opening popover â†’ store initial value
      setTempFormatValues((prev) => ({
        ...prev,
        [screenCode]: formatValues[screenCode] ?? 1,
      }));
      setPopoverInitialFormatValue((prev) => ({
        ...prev,
        [screenCode]: formatValues[screenCode] ?? 1,
      }));
      setFormatPopoverVisible(screenCode);
    }
  };

  const mappedData = data.map((dat, index) => {
    return { ...dat, key: index };
  });

  const history = useHistory();

  const handleMenuClick = (e, screenData) => {
    // message.info(`Click on menu item.${e.key}`);

    switch (e.key) {
      case "manage_publish_schedule":
        PopupManager.launchPublishingScheduleManagerPopup(screenData);
        break;
      case "view_publish_history":
        setPublishingHistoryScreenData(screenData);
        setPublishingHistoryVisible(true);
        break;
      case "unpair_device":
        onNeedsUnpair(screenData);
        break;
    }
  };

  /* â”€â”€ Shared menu item component â”€â”€ */
  const MenuItem = ({
    icon,
    iconBg,
    iconColor,
    title,
    desc,
    textColor = "#0f172a",
    hoverBg = "#f8fafc",
    onClick,
  }) => {
    const [hovered, setHovered] = React.useState(false);
    return (
      <button
        onClick={onClick}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          width: "100%",
          padding: "10px 20px",
          borderRadius: 0,
          border: "none",
          background: hovered ? hoverBg : "transparent",
          cursor: "pointer",
          textAlign: "left",
          transition: "background 0.15s ease",
        }}
      >
        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            width: 34,
            height: 34,
            borderRadius: 10,
            background: iconBg,
            flexShrink: 0,
            transition: "transform 0.15s ease",
            transform: hovered ? "scale(1.08)" : "scale(1)",
          }}
        >
          {React.cloneElement(icon, {
            style: { color: iconColor, fontSize: 14 },
          })}
        </span>
        <div style={{ lineHeight: 1.35, minWidth: 0 }}>
          <div style={{ fontWeight: 600, color: textColor, fontSize: 13 }}>
            {title}
          </div>
          <div
            style={{
              fontSize: 11,
              color: "#94a3b8",
              fontWeight: 400,
              marginTop: 1,
            }}
          >
            {desc}
          </div>
        </div>
      </button>
    );
  };

  /* â”€â”€ Display Settings dropdown button (shared across all views) â”€â”€ */
  const DisplayDropdown = ({ record }) => {
    const screenCode = record?.ScreenCode;
    const closeDisplay = () => setOpenDisplayCode(null);
    const btnRef = React.useRef(null);

    const handleOpenChange = (v) => {
      if (v && btnRef.current) {
        const rect = btnRef.current.getBoundingClientRect();
        const MARGIN = 16;
        // account for fixed top navbar/header
        const headerEl = document.querySelector(
          ".ant-layout-header, header, nav",
        );
        const headerHeight = headerEl
          ? headerEl.getBoundingClientRect().bottom
          : 64;
        const spaceBelow = window.innerHeight - rect.bottom - MARGIN;
        const spaceAbove = rect.top - headerHeight - MARGIN;
        if (spaceBelow >= spaceAbove) {
          setDisplayPlacement("bottomRight");
          setDisplayMaxHeight(`${Math.max(spaceBelow, 120)}px`);
        } else {
          setDisplayPlacement("topRight");
          setDisplayMaxHeight(`${Math.max(spaceAbove, 120)}px`);
        }
      }
      setOpenDisplayCode(v ? screenCode : null);
    };

    const displayContent = (
      <div
        style={{
          padding: "6px",
          borderRadius: 16,
          minWidth: 230,
          background: "#ffffff",
          overflowY: "auto",
          maxHeight: displayMaxHeight,
        }}
      >
        <div
          style={{
            padding: "8px 12px 6px",
            marginBottom: 4,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#94a3b8",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            {record?.ScreenName || "Screen"}
          </div>
        </div>
        <div style={{ padding: "4px 0" }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#cbd5e1",
              letterSpacing: "0.07em",
              textTransform: "uppercase",
              padding: "4px 12px 2px",
            }}
          >
            Display Settings
          </div>
          <MenuItem
            icon={<FormatPainterFilled />}
            iconBg="linear-gradient(135deg,#eff6ff,#dbeafe)"
            iconColor="#3b82f6"
            title="Adjust Saturation"
            desc="Fine-tune color saturation"
            hoverBg="#eff6ff"
            onClick={() => {
              closeDisplay();
              setSaturationModalScreen(record);
            }}
          />
          {editBrightness && (
            <MenuItem
              icon={<Sun size={14} />}
              iconBg="linear-gradient(135deg,#fffbeb,#fef3c7)"
              iconColor="#ca8a04"
              title="Brightness Manager"
              desc="Set brightness schedules"
              hoverBg="#fffbeb"
              onClick={() => {
                closeDisplay();
                onEditBrightness(record);
              }}
            />
          )}
        </div>
        {!!screensStatus[screenCode]?.is_paired && (
          <>
            <div
              style={{ height: 1, background: "#f1f5f9", margin: "4px 0" }}
            />
            <div style={{ padding: "4px 0" }}>
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#cbd5e1",
                  letterSpacing: "0.07em",
                  textTransform: "uppercase",
                  padding: "4px 12px 2px",
                }}
              >
                Player
              </div>
              <MenuItem
                icon={
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_play.svg"
                    style={{ width: 14, height: 14 }}
                  />
                }
                iconBg="linear-gradient(135deg,#f0fdf4,#dcfce7)"
                iconColor="#16a34a"
                title="Play Content"
                desc="Resume playback on this screen"
                hoverBg="#f0fdf4"
                onClick={() => {
                  closeDisplay();
                  onPreRemoteAction(record, "toggle_play");
                }}
              />
              <MenuItem
                icon={
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_stop.svg"
                    style={{ width: 14, height: 14 }}
                  />
                }
                iconBg="linear-gradient(135deg,#f8fafc,#f1f5f9)"
                iconColor="#64748b"
                title="Stop Content"
                desc="Pause playback on this screen"
                hoverBg="#f8fafc"
                onClick={() => {
                  closeDisplay();
                  onPreRemoteAction(record, "toggle_play");
                }}
              />
              <MenuItem
                icon={
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_reload.svg"
                    style={{ width: 14, height: 14 }}
                  />
                }
                iconBg="linear-gradient(135deg,#eff6ff,#dbeafe)"
                iconColor="#3b82f6"
                title="Reload Content"
                desc="Restart the player app"
                hoverBg="#eff6ff"
                onClick={() => {
                  closeDisplay();
                  onPreRemoteAction(record, "reload_player");
                }}
              />
            </div>
            <div
              style={{ height: 1, background: "#f1f5f9", margin: "4px 0" }}
            />
            <div style={{ padding: "4px 0" }}>
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#cbd5e1",
                  letterSpacing: "0.07em",
                  textTransform: "uppercase",
                  padding: "4px 12px 2px",
                }}
              >
                Hardware
              </div>
              <MenuItem
                icon={
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_hardware_reboot.svg"
                    style={{ width: 14, height: 14 }}
                  />
                }
                iconBg="linear-gradient(135deg,#fff7ed,#ffedd5)"
                iconColor="#f97316"
                title="Reboot Device"
                desc="Restart the hardware device"
                hoverBg="#fff7ed"
                onClick={() => {
                  closeDisplay();
                  onPreRemoteAction(record, "reboot_hardware");
                }}
              />
              <MenuItem
                icon={
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_hardware_shutdown.svg"
                    style={{ width: 14, height: 14 }}
                  />
                }
                iconBg="linear-gradient(135deg,#fff1f2,#ffe4e6)"
                iconColor="#ef4444"
                title="Shutdown Device"
                desc="Power off the hardware device"
                textColor="#ef4444"
                hoverBg="#fff1f2"
                onClick={() => {
                  closeDisplay();
                  onPreRemoteAction(record, "shutdown_hardware");
                }}
              />
            </div>
          </>
        )}
      </div>
    );

    return (
      <Popover
        content={displayContent}
        trigger="click"
        placement={displayPlacement}
        open={openDisplayCode === screenCode}
        onOpenChange={handleOpenChange}
        overlayInnerStyle={{
          padding: 0,
          borderRadius: 16,
          boxShadow: "none",
          overflow: "hidden",
        }}
      >
        <Tooltip title="Device Controller" placement="top">
          <button
            ref={btnRef}
            style={{
              width: 30,
              height: 30,
              borderRadius: 7,
              border: "1px solid #e2e8f0",
              background: "#f8fafc",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "#64748b",
            }}
          >
            <MdOutlineSettingsRemote size={16} />
            {/* <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <rect x="7" y="2" width="10" height="20" rx="3" />
              <circle
                cx="12"
                cy="7"
                r="1.5"
                fill="currentColor"
                stroke="none"
              />
              <circle cx="9" cy="13" r="1" fill="currentColor" stroke="none" />
              <circle cx="12" cy="13" r="1" fill="currentColor" stroke="none" />
              <circle cx="15" cy="13" r="1" fill="currentColor" stroke="none" />
              <circle cx="9" cy="17" r="1" fill="currentColor" stroke="none" />
              <circle cx="12" cy="17" r="1" fill="currentColor" stroke="none" />
              <circle cx="15" cy="17" r="1" fill="currentColor" stroke="none" />
            </svg> */}
          </button>
        </Tooltip>
      </Popover>
    );
  };

  const getMenu = (screenData, onClose = () => {}) => {
    const isPairedScreen =
      screenData && !!screensStatus[screenData.ScreenCode]?.is_paired;

    return (
      <div
        style={{
          padding: "6px",
          borderRadius: 16,
          minWidth: 230,
          background: "#ffffff",
          boxShadow:
            "0 12px 40px rgba(15,23,42,0.12), 0 2px 8px rgba(15,23,42,0.06)",
          border: "1px solid #f1f5f9",
          overflow: "auto",
          maxHeight: actionMaxHeight,
        }}
      >
        {/* Header */}
        <div
          style={{
            padding: "8px 12px 6px",
            marginBottom: 4,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#94a3b8",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
            }}
          >
            {screenData?.ScreenName || "Screen"}
          </div>
        </div>

        {/* Publishing section */}
        <div style={{ padding: "4px 0" }}>
          <div
            style={{
              fontSize: 10,
              fontWeight: 700,
              color: "#cbd5e1",
              letterSpacing: "0.07em",
              textTransform: "uppercase",
              padding: "4px 12px 2px",
            }}
          >
            Publishing
          </div>
          <MenuItem
            icon={<ClockCircleOutlined />}
            iconBg="linear-gradient(135deg,#eff6ff,#dbeafe)"
            iconColor="#3b82f6"
            title={t.menuScheduleTitle}
            desc={t.menuScheduleDesc}
            hoverBg="#eff6ff"
            onClick={() => {
              onClose();
              handleMenuClick({ key: "manage_publish_schedule" }, screenData);
            }}
          />
          <MenuItem
            icon={<HistoryOutlined />}
            iconBg="linear-gradient(135deg,#f0fdf4,#dcfce7)"
            iconColor="#16a34a"
            title={t.menuHistoryTitle}
            desc={t.menuHistoryDesc}
            hoverBg="#f0fdf4"
            onClick={() => {
              onClose();
              handleMenuClick({ key: "view_publish_history" }, screenData);
            }}
          />
        </div>

        {/* Device section — only when paired */}
        {isPairedScreen && (
          <>
            <div
              style={{ height: 1, background: "#f1f5f9", margin: "4px 0" }}
            />
            <div style={{ padding: "4px 0" }}>
              <div
                style={{
                  fontSize: 10,
                  fontWeight: 700,
                  color: "#cbd5e1",
                  letterSpacing: "0.07em",
                  textTransform: "uppercase",
                  padding: "4px 12px 2px",
                }}
              >
                Device
              </div>
              <MenuItem
                icon={<DisconnectOutlined />}
                iconBg="linear-gradient(135deg,#fff1f2,#ffe4e6)"
                iconColor="#ef4444"
                title={t.menuUnpairTitle || "Unpair Device"}
                desc={t.menuUnpairDesc || "Disconnect the physical display"}
                textColor="#ef4444"
                hoverBg="#fff1f2"
                onClick={() => {
                  onClose();
                  handleMenuClick({ key: "unpair_device" }, screenData);
                }}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  const handleFirebase = () => {
    try {
      if (!data.length) return;

      // Guard: check if firebase.database is available
      if (!firebase || !firebase.database) {
        console.warn("Firebase is not available, skipping realtime listeners");
        return;
      }

      const {
        AccountCode = "",
        BrandCode = "",
        BranchCode = "",
        ScreenCode = "",
      } = data[0];

      if (db) {
        db.off("child_changed");
        db.off("child_added");
        db = null;
      }
      db = firebase
        .database()
        .ref()
        .child(`${AccountCode}/${BrandCode}/${BranchCode}`);

      db.on("child_changed", (snap) => {
        screensStatus[snap.key] = { ...screensStatus[snap.key], ...snap.val() };
        setScreensStatus({ ...screensStatus });

        // Update saturation values when firebase changes
        if ("saturation" in snap.val()) {
          setFormatValues((prev) => ({
            ...prev,
            [snap.key]: snap.val().saturation,
          }));
          setTempFormatValues((prev) => ({
            ...prev,
            [snap.key]: snap.val().saturation,
          }));
        }
      });

      db.on("child_added", (snap) => {
        if (!screensStatus[snap.key]) {
          screensStatus[snap.key] = {};
        }
        screensStatus[snap.key] = { ...screensStatus[snap.key], ...snap.val() };
        setScreensStatus({ ...screensStatus });
        if ("saturation" in snap.val()) {
          setFormatValues((prev) => ({
            ...prev,
            [snap.key]: snap.val().saturation,
          }));
          setTempFormatValues((prev) => ({
            ...prev,
            [snap.key]: snap.val().saturation,
          }));
        }
      });
    } catch (error) {
      console.warn("Firebase initialization failed in ScreenTableView:", error);
    }
  };
  useEffect(() => {
    handleFirebase();
  }, []);

  useEffect(() => {
    handleFirebase();
  }, [data]);

  const screens = Grid.useBreakpoint();

  const onScreenEventUpdated = () => {
    onNeedsReload();
  };
  const willCreateScreenEvent = (callback = () => {}, data) => {
    PopupManager.launchCreateScreenEventPopup(callback, data);
  };

  const onPreRemoteAction = (screenData, action) => {
    const screenCode = screenData.ScreenCode;
    onRemoteAction(action, screensStatus[screenCode], screenData);
  };

  const launchCreateScreenEventPlaylistPopup = (screenData) => {
    PopupManager.launchCreateScreenEventPlaylistPopup(
      () => {
        onNeedsReload();
      },
      screenData,
      eventTypesData,
    );
  };

  const createPermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_SCREEN,
    PermissionManager.PERMISSION_TYPE_CREATE,
  );
  const editPermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_SCREEN,
    PermissionManager.PERMISSION_TYPE_EDIT,
  );
  const editBrightness = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_SCREEN,
    PermissionManager.PERMISSION_TYPE_EDIT,
  );
  const deletePermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_SCREEN,
    PermissionManager.PERMISSION_TYPE_DELETE,
  );
  const viewCampaignPermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_CAMPAIGN,
    PermissionManager.PERMISSION_TYPE_LIST,
  );
  const allowPublishPermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_SCREEN,
    PermissionManager.PERMISSION_TYPE_PUBLISH,
  );
  const viewEventPermission = PermissionManager.checkPermission(
    PermissionManager.PERMISSION_KEY_EVENT,
    PermissionManager.PERMISSION_TYPE_LIST,
  );

  const { selectPage } = parentProps;
  const isMobile = screens.md === false;

  const sortedData = [...mappedData].sort((a, b) => {
    if (!sortBy) return 0;
    let result = 0;
    if (sortBy === "name") {
      result = (a.ScreenName || "").localeCompare(b.ScreenName || "");
    } else if (sortBy === "pending") {
      result = (b.PendingPublished ?? 0) - (a.PendingPublished ?? 0);
    } else if (sortBy === "online") {
      const aOnline = screensStatus[a.ScreenCode]?.is_online ?? 0;
      const bOnline = screensStatus[b.ScreenCode]?.is_online ?? 0;
      result = bOnline - aOnline;
    } else if (sortBy === "campaign") {
      result = (a.CampaignName || "").localeCompare(b.CampaignName || "");
    }
    return sortDir === "asc" ? result : -result;
  });

  const handleSort = (key) => {
    if (sortBy === key) {
      if (sortDir === "asc") {
        setSortDir("desc");
      } else {
        setSortBy(null);
        setSortDir("asc");
      }
    } else {
      setSortBy(key);
      setSortDir("asc");
    }
  };

  const SortCarets = ({ field }) => {
    const active = sortBy === field;
    const up = active && sortDir === "asc";
    const down = active && sortDir === "desc";
    const activeColor = "#6366f1";
    const inactiveColor = "#cbd5e1";
    return (
      <span
        style={{
          display: "inline-flex",
          flexDirection: "column",
          marginLeft: 4,
          gap: 1.5,
          flexShrink: 0,
          verticalAlign: "middle",
        }}
      >
        <span
          style={{
            width: 0,
            height: 0,
            borderLeft: "3.5px solid transparent",
            borderRight: "3.5px solid transparent",
            borderBottom: `4px solid ${up ? activeColor : inactiveColor}`,
          }}
        />
        <span
          style={{
            width: 0,
            height: 0,
            borderLeft: "3.5px solid transparent",
            borderRight: "3.5px solid transparent",
            borderTop: `4px solid ${down ? activeColor : inactiveColor}`,
          }}
        />
      </span>
    );
  };

  const SORT_OPTIONS = [
    { key: "name", label: t.sortName },
    { key: "online", label: t.sortOnline },
    { key: "pending", label: t.sortPending },
  ];

  const sortBar = (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        marginBottom: 12,
      }}
    >
      <span
        style={{
          fontSize: 12,
          color: "#94a3b8",
          fontWeight: 500,
          marginRight: 2,
        }}
      >
        {t.sortBy}
      </span>
      {SORT_OPTIONS.map((opt) => (
        <button
          key={opt.key}
          onClick={() => handleSort(opt.key)}
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: 4,
            padding: "4px 12px",
            borderRadius: 20,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            border: "none",
            transition: "all 0.15s",
            background:
              sortBy === opt.key
                ? "linear-gradient(135deg,#6366f1,#4f46e5)"
                : "#f1f5f9",
            color: sortBy === opt.key ? "#fff" : "#64748b",
            boxShadow:
              sortBy === opt.key ? "0 2px 8px rgba(99,102,241,0.25)" : "none",
          }}
        >
          {opt.label}
          {sortBy === opt.key &&
            (sortDir === "asc" ? (
              <ArrowUp size={11} strokeWidth={2.5} />
            ) : (
              <ArrowDown size={11} strokeWidth={2.5} />
            ))}
        </button>
      ))}
    </div>
  );

  const renderMobileCards = () => {
    if (sortedData.length === 0) return renderNoScreensState();
    return sortedData.map((record, index) => {
      const {
        ScreenCode,
        ScreenName,
        CampaignName,
        CampaignID,
        PendingPublished = 0,
      } = record;
      const statusData = screensStatus[ScreenCode] || {};
      const isOnline = statusData.is_online ?? 0;
      const licenseActive = !CHECK_LICENSE
        ? true
        : "LicenseStatus" in record
          ? record.LicenseStatus === "active"
          : false;
      const isDisabled = CHECK_LICENSE && !licenseActive;

      const campaignBTN =
        CampaignName === "" ? (
          !editPermission ? (
            <Button disabled type="link" size="small">
              {t.noCampaign}
            </Button>
          ) : (
            <Button
              onClick={() => onCampaignClicked(record)}
              type="link"
              size="small"
            >
              {t.addCampaign}
            </Button>
          )
        ) : (
          <button
            onClick={() => viewCampaignPermission && onCampaignClicked(record)}
            style={{
              background: "#fff",
              border: "1px dashed #cbd5e1",
              borderRadius: 20,
              padding: "3px 10px",
              fontSize: 12,
              fontWeight: 500,
              color: viewCampaignPermission ? "#334155" : "#94a3b8",
              cursor: viewCampaignPermission ? "pointer" : "not-allowed",
              width: 200,
              textAlign: "center",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              display: "block",
              transition: "border-color 0.15s, background 0.15s",
            }}
            onMouseEnter={(e) => {
              if (viewCampaignPermission) {
                e.currentTarget.style.borderColor = "#94a3b8";
                e.currentTarget.style.borderStyle = "solid";
                e.currentTarget.style.background = "#f8fafc";
                e.currentTarget.style.color = "#2563eb";
              }
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#cbd5e1";
              e.currentTarget.style.borderStyle = "dashed";
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.color = "#334155";
            }}
          >
            {CampaignName}
          </button>
        );

      let publishBtn = null;
      if (allowPublishPermission) {
        if (!licenseActive) {
          publishBtn = (
            <Button
              size="small"
              onClick={() => selectPage(Constants.LICENSE_PAGE)}
              className="btn-purple"
              type="dashed"
            >
              {t.manageLicense}
            </Button>
          );
        } else if (!CampaignID || CampaignID === "") {
          publishBtn = (
            <Button size="small" disabled type="primary">
              {t.publish}
            </Button>
          );
        } else {
          const title = isOnline ? t.publishInstant : t.publishWhenOnline;
          publishBtn = (
            <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <Button
                size="small"
                type="primary"
                style={{ borderRadius: 6 }}
                onClick={() => {
                  Modal.confirm({
                    title,
                    icon: <ExclamationCircleOutlined />,
                    okText: "Yes",
                    cancelText: "No",
                    centered: true,
                    onOk: () => onPublish(record),
                  });
                }}
              >
                {t.publish}
              </Button>
              <Popover
                content={getMenu(record, () => setOpenPopoverCode(null))}
                trigger="click"
                placement="bottomRight"
                open={openPopoverCode === ScreenCode}
                onOpenChange={(v) => setOpenPopoverCode(v ? ScreenCode : null)}
                overlayInnerStyle={{
                  padding: 0,
                  borderRadius: 16,
                  boxShadow: "none",
                }}
              >
                <Button
                  size="small"
                  icon={<ClockCircleOutlined />}
                  style={{ borderRadius: 6 }}
                />
              </Popover>
            </div>
          );
        }
      }

      return (
        <motion.div key={ScreenCode || index} variants={Animations.LIST_ITEM}>
          <Card
            size="small"
            style={{
              opacity: isDisabled ? 0.6 : 1,
              borderRadius: 12,
              boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
              marginBottom: 12,
              cursor: "pointer",
            }}
            bodyStyle={{ padding: "12px 16px" }}
            onClick={() => setSelectedScreen(record)}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: 8,
              }}
            >
              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                  fontWeight: 600,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {ScreenName}
                {PendingPublished === 1 && (
                  <Tag
                    icon={<ExclamationCircleOutlined />}
                    color="orange"
                    style={{ fontSize: 11, marginLeft: 6 }}
                  >
                    Pending
                  </Tag>
                )}
              </div>
              {licenseActive ? (
                isOnline === 1 ? (
                  <span className="screen-status-badge online">
                    <span className="status-dot" />
                    {t.online}
                  </span>
                ) : (
                  <span className="screen-status-badge offline">
                    <span className="status-dot" />
                    {t.offline}
                  </span>
                )
              ) : (
                <Tag color="warning">
                  <LockOutlined /> No License
                </Tag>
              )}
            </div>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                marginBottom: 10,
              }}
            >
              <span style={{ fontSize: 12, color: "#888" }}>
                {t.campaign}:
              </span>
              {USE_CAMPAIGN_SYNC && record.CampaignSync && (
                <Tooltip title="CampaignSync is Enabled">
                  <PartitionOutlined style={{ color: "#ff4d4f" }} />
                </Tooltip>
              )}
              {campaignBTN}
            </div>
            <div
              onClick={(e) => e.stopPropagation()}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <ActionButton
                  visible={editBrightness}
                  onClicked={() => onEditBrightness(record)}
                  title={t.brightness}
                  showTitle={false}
                  icon="/cms/assets/svgs/icons/brightness_icon.svg"
                />
                <ActionButton
                  visible={editPermission}
                  onClicked={() => onEdit(record)}
                  title={t.edit}
                  showTitle={false}
                  icon="/cms/assets/svgs/icons/edit_icon.svg"
                />
                <ActionButton
                  visible={deletePermission}
                  confirmText={t.deleteConfirm}
                  onClicked={() => onDelete(record)}
                  title={t.delete}
                  showTitle={false}
                  icon="/cms/assets/svgs/icons/trash_icon.svg"
                />
              </div>
              {publishBtn}
            </div>
          </Card>
        </motion.div>
      );
    });
  };

  const renderDesktopCards = () => {
    if (sortedData.length === 0) return renderNoScreensState();
    return sortedData.map((record, index) => {
      const {
        ScreenCode,
        ScreenName,
        CampaignName,
        CampaignID,
        PendingPublished = 0,
        ScreenID,
      } = record;

      if (!screensStatus[ScreenCode]) screensStatus[ScreenCode] = {};

      const isOnline = screensStatus[ScreenCode].is_online ?? 0;
      const isPlaying = screensStatus[ScreenCode].is_playing ?? 0;
      const isPaired = screensStatus[ScreenCode].is_paired ?? 0;
      const os = screensStatus[ScreenCode].os ?? "";
      const osVersion = screensStatus[ScreenCode].os_version ?? "";
      const playerVersion = screensStatus[ScreenCode].player_version ?? null;
      const isLocked = screensStatus[ScreenCode].lock
        ? screensStatus[ScreenCode].lock !== 0
        : false;

      const hasLicense = "LicenseKey" in record;
      const licenseActive = !CHECK_LICENSE
        ? true
        : "LicenseStatus" in record
          ? record.LicenseStatus === "active"
          : false;
      const isDisabled = CHECK_LICENSE && !licenseActive;

      const now = new Date();
      const colorMap = {
        "No License": THEME_PALLETE.red,
        "License Active": "#52c41a",
        "License not started": "#1890ff",
        "License expired": "#fa8c16",
        "License Inactive": "#d9d9d9",
      };
      const inActiveReason = !hasLicense
        ? "No License"
        : licenseActive
          ? "License Active"
          : now < new Date(record.LicenseStartDate)
            ? "License not started"
            : now > new Date(record.LicenseEndDate)
              ? "License expired"
              : "License Inactive";

      const screencode = `${record.AccountCode}-${record.BrandCode}-${record.BranchCode}-${record.ScreenCode}`;

      const { requestServerPost, usertoken } = parentProps;

      const updateScreenCampaign = (newCampaignID) => {
        const params = new FormData();
        params.append("screenid", ScreenID);
        params.append("campaignid", newCampaignID);
        requestServerPost(
          "update_screen",
          params,
          {},
          () => {
            setCampaignPopoverVisible(null);
            onNeedsReload();
          },
          usertoken,
        );
      };

      // Popover is only used when no campaign is linked (to select one)
      const campaignPopoverContent = (
        <div style={{ width: 280 }}>
          <div
            style={{
              fontSize: 12,
              color: "#64748b",
              marginBottom: 8,
              fontWeight: 500,
            }}
          >
            Link a campaign
          </div>
          <CampaignSelector
            value={-1}
            onSelect={(val) => updateScreenCampaign(val)}
            getPopupContainer={(trigger) =>
              trigger.closest(".ant-popover-inner-content") || document.body
            }
            parentProps={parentProps}
          />
        </div>
      );

      const hasLinkedCampaign = !!(CampaignID && CampaignID !== "");

      const campaignChip = editPermission ? (
        hasLinkedCampaign ? (
          /* Linked: dashed tag — left clicks navigate, right × unlinks */
          <div
            style={{
              display: "inline-flex",
              alignItems: "stretch",
              borderRadius: 20,
              border: "1px dashed #cbd5e1",
              background: "#fff",
              overflow: "hidden",
              fontSize: 12,
              width: 200,
              transition: "border-color 0.15s, background 0.15s",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#94a3b8";
              e.currentTarget.style.borderStyle = "solid";
              e.currentTarget.style.background = "#f8fafc";
              e.currentTarget.style.color = "#2563eb";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#cbd5e1";
              e.currentTarget.style.borderStyle = "dashed";
              e.currentTarget.style.background = "#fff";
              e.currentTarget.style.color = "#334155";
            }}
          >
            <Tooltip
              title={`Go to schedule: ${CampaignName}`}
              placement="top"
              mouseEnterDelay={0.6}
            >
              <button
                onClick={() => onCampaignClicked(record)}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "3px 8px 3px 10px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                <span
                  style={{
                    fontWeight: 500,
                    color: "#334155",
                    letterSpacing: "0.01em",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                  }}
                >
                  {CampaignName}
                </span>
                {USE_CAMPAIGN_SYNC && record.CampaignSync && (
                  <Tooltip title="CampaignSync is Enabled">
                    <PartitionOutlined style={{ color: "#ff4d4f" }} />
                  </Tooltip>
                )}
              </button>
            </Tooltip>
            {/* Separator + unlink zone */}
            <div
              style={{
                width: 1,
                background: "#cbd5e1",
                margin: "4px 0",
                flexShrink: 0,
              }}
            />
            <Tooltip
              title="Unlink campaign"
              placement="top"
              mouseEnterDelay={0.4}
            >
              <button
                onClick={() => updateScreenCampaign("")}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "4px 10px",
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  color: "#a78bfa",
                  fontSize: 18,
                  lineHeight: 1,
                  transition: "color 0.15s, background 0.15s",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#ef4444";
                  e.currentTarget.style.background = "#fff1f2";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#a78bfa";
                  e.currentTarget.style.background = "transparent";
                }}
              >
                <CloseOutlined style={{ fontSize: 12 }} />
              </button>
            </Tooltip>
          </div>
        ) : (
          /* Not linked: click opens campaign selector */
          <Tooltip
            title="Click to link a campaign"
            placement="top"
            mouseEnterDelay={0.6}
          >
            <Popover
              content={campaignPopoverContent}
              title={null}
              trigger="click"
              placement="bottomLeft"
              open={campaignPopoverVisible === ScreenCode}
              onOpenChange={(v) =>
                setCampaignPopoverVisible(v ? ScreenCode : null)
              }
              overlayStyle={{ zIndex: 2000 }}
              overlayInnerStyle={{ borderRadius: 12, padding: "12px 14px" }}
            >
              <button
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 5,
                  padding: "4px 10px",
                  borderRadius: 20,
                  background: "linear-gradient(135deg, #fffbeb, #fef3c7)",
                  border: "1.5px solid #fcd34d",
                  fontSize: 12,
                  cursor: "pointer",
                }}
              >
                <LayoutTemplate size={11} strokeWidth={2.2} color="#d97706" />
                <span
                  style={{
                    fontWeight: 600,
                    color: "#b45309",
                    letterSpacing: "0.01em",
                  }}
                >
                  {t.noCampaignLabel || "No Campaign"}
                </span>
                <span style={{ fontSize: 10, color: "#d97706", lineHeight: 1 }}>
                  <CaretDownOutlined />
                </span>
              </button>
            </Popover>
          </Tooltip>
        )
      ) : (
        /* read-only chip for users without edit permission */
        <Tooltip
          title={
            hasLinkedCampaign
              ? `Linked campaign: ${CampaignName}`
              : "No campaign linked"
          }
          placement="top"
          mouseEnterDelay={0.6}
        >
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "3px 10px",
              borderRadius: 20,
              background: "#fff",
              border: hasLinkedCampaign
                ? "1px dashed #cbd5e1"
                : "1px dashed #fcd34d",
              fontSize: 12,
              width: 200,
              overflow: "hidden",
            }}
          >
            <span
              style={{
                fontWeight: 500,
                color: hasLinkedCampaign ? "#334155" : "#b45309",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {hasLinkedCampaign
                ? CampaignName
                : t.noCampaignLabel || "No Campaign"}
            </span>
          </div>
        </Tooltip>
      );

      const screenevents = (updatedEventData ? updatedEventData : eventData)
        .filter((e) => e.ScreenID === ScreenID)
        .sort((a, b) => b.Priority - a.Priority);

      const eventsContent =
        screenevents.length > 0 ? (
          <ScreenEventPlaylistModule
            onDataUpdated={(newEventData) => setUpdatedEventData(newEventData)}
            onSave={onScreenEventUpdated}
            eventTypesData={eventTypesData}
            data={screenevents}
            screenData={record}
          />
        ) : (
          <Button
            icon={<PlusCircleOutlined />}
            disabled={!createPermission}
            onClick={() => launchCreateScreenEventPlaylistPopup(record)}
            shape="round"
            type="link"
            size="small"
          >
            {t.addEvent}
          </Button>
        );

      const statusBadge = licenseActive ? (
        isOnline === 1 ? (
          <span className="screen-status-badge online">
            <span className="status-dot" />
            {t.online}
          </span>
        ) : (
          <span className="screen-status-badge offline">
            <span className="status-dot" />
            {t.offline}
          </span>
        )
      ) : (
        <Tag
          style={{
            color: colorMap[inActiveReason],
            border: `1px solid ${colorMap[inActiveReason]}`,
          }}
        >
          <LockOutlined /> {inActiveReason}
        </Tag>
      );

      let publishBtn = null;
      if (allowPublishPermission) {
        if (!licenseActive) {
          publishBtn = (
            <Tooltip title={t.manageLicenseTooltip}>
              <Button
                onClick={() => selectPage(Constants.LICENSE_PAGE)}
                size="small"
                style={{
                  borderRadius: 8,
                  fontWeight: 600,
                  borderColor: "#a855f7",
                  color: "#a855f7",
                  background: "#faf5ff",
                }}
              >
                {t.manageLicense}
              </Button>
            </Tooltip>
          );
        } else if (!CampaignID || CampaignID === "") {
          publishBtn = (
            <Tooltip title={t.publishTooltip}>
              <Button
                disabled
                size="small"
                style={{ borderRadius: 8, fontWeight: 600 }}
              >
                {t.publish}
              </Button>
            </Tooltip>
          );
        } else {
          const hasPending = PendingPublished === 1;
          const title = isOnline ? t.publishInstant : t.publishWhenOnline;
          const btnStyle =
            hasPending && isOnline
              ? {
                  borderRadius: 8,
                  fontWeight: 700,
                  background: "linear-gradient(135deg,#f97316,#ea580c)",
                  borderColor: "#ea580c",
                  color: "#fff",
                  boxShadow: "0 0 0 3px rgba(249,115,22,0.20)",
                  animation: "pulse-orange 1.8s infinite",
                }
              : hasPending
                ? {
                    borderRadius: 8,
                    fontWeight: 700,
                    background: "linear-gradient(135deg,#fb923c,#f97316)",
                    borderColor: "#f97316",
                    color: "#fff",
                  }
                : {
                    borderRadius: 8,
                    fontWeight: 600,
                    background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                    borderColor: "#4f46e5",
                    color: "#fff",
                    boxShadow: "0 2px 8px rgba(99,102,241,0.25)",
                  };
          publishBtn = (
            <Button.Group>
              <Popconfirm
                title={title}
                onConfirm={() => onPublish(record)}
                okText={t.publish}
                cancelText={t.cancel}
              >
                <Button size="small" style={btnStyle} type="primary">
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                    }}
                  >
                    <Send size={12} />
                    {hasPending ? t.publishNow : t.publish}
                  </span>
                </Button>
              </Popconfirm>
              <Popover
                content={getMenu(record, () => setOpenPopoverCode(null))}
                trigger="click"
                placement={actionPlacement}
                open={openPopoverCode === ScreenCode}
                onOpenChange={(v) => {
                  if (!v) setOpenPopoverCode(null);
                }}
                overlayInnerStyle={{
                  padding: 0,
                  borderRadius: 16,
                  boxShadow: "none",
                }}
              >
                <Button
                  size="small"
                  icon={<ClockCircleOutlined />}
                  onClick={(e) => {
                    computeActionPlacement(e.currentTarget);
                    setOpenPopoverCode(ScreenCode);
                  }}
                />
              </Popover>
            </Button.Group>
          );
        }
      }

      return (
        <motion.div
          key={ScreenCode || index}
          variants={Animations.LIST_ITEM}
          style={{
            backgroundColor: "#fff",
            border:
              PendingPublished === 1 && isOnline === 1
                ? "1.5px solid #fb923c"
                : "1px solid #e8ecf3",
            borderRadius: 18,
            marginBottom: 12,
            opacity: isDisabled ? 0.6 : 1,
            boxShadow:
              PendingPublished === 1 && isOnline === 1
                ? "0 0 0 3px rgba(249,115,22,0.08), 0 1px 4px rgba(0,0,0,0.05)"
                : "0 0 0 0px rgba(0,0,0,0), 0 1px 4px rgba(0,0,0,0.05)",
            overflow: "hidden",
            display: "flex",
            transition: "box-shadow 0.2s ease, border-color 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.boxShadow =
              "0 0 0 0px rgba(0,0,0,0), 0 4px 16px rgba(99,102,241,0.10)";
            e.currentTarget.style.borderColor =
              PendingPublished === 1 && isOnline === 1 ? "#fb923c" : "#c7d2fe";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.boxShadow =
              PendingPublished === 1 && isOnline === 1
                ? "0 0 0 3px rgba(249,115,22,0.08), 0 1px 4px rgba(0,0,0,0.05)"
                : "0 0 0 0px rgba(0,0,0,0), 0 1px 4px rgba(0,0,0,0.05)";
            e.currentTarget.style.borderColor =
              PendingPublished === 1 && isOnline === 1 ? "#fb923c" : "#e8ecf3";
          }}
        >
          {/* Accent bar — color reflects screen health */}
          <div
            style={{
              width: 4,
              alignSelf: "stretch",
              flexShrink: 0,
              background: isLocked
                ? "linear-gradient(180deg, #ef4444, #dc2626)"
                : !licenseActive
                  ? "linear-gradient(180deg, #94a3b8, #64748b)"
                  : isOnline === 1 &&
                      isPaired === 1 &&
                      CampaignID &&
                      CampaignID !== ""
                    ? "linear-gradient(180deg, #22c55e, #16a34a)"
                    : isOnline === 1 &&
                        (isPaired === 0 || !CampaignID || CampaignID === "")
                      ? "linear-gradient(180deg, #f59e0b, #d97706)"
                      : isOnline !== 1
                        ? "linear-gradient(180deg, #94a3b8, #64748b)"
                        : "linear-gradient(180deg, #818cf8, #6366f1)",
              transition: "background 0.4s ease",
            }}
          />
          {/* Main content */}
          <div style={{ flex: 1, minWidth: 0 }}>
            {/* Header: icon column + name/status */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                padding: "14px 20px 12px",
                borderBottom: "1px solid #f8fafc",
                cursor: "pointer",
                gap: 14,
              }}
              onClick={() => setSelectedScreen(record)}
            >
              {/* Icon column */}
              <div style={{ flexShrink: 0 }}>
                <ScreenIconView
                  isLocked={isLocked}
                  screensStatus={screensStatus}
                  onRemoteAction={onRemoteAction}
                  name={ScreenName}
                  screencode={screencode}
                  onScreenClicked={onScreenClicked}
                  record={record}
                  iconOnly
                />
              </div>
              {/* Name + pending tag */}
              <div
                style={{
                  flex: 1,
                  minWidth: 0,
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <ScreenIconView
                  isLocked={isLocked}
                  screensStatus={screensStatus}
                  onRemoteAction={onRemoteAction}
                  name={ScreenName}
                  screencode={screencode}
                  onScreenClicked={onScreenClicked}
                  record={record}
                  nameOnly
                />
                {PendingPublished === 1 && (
                  <Tag
                    icon={<ExclamationCircleOutlined />}
                    color="orange"
                    style={{ fontSize: 11 }}
                  >
                    Pending
                  </Tag>
                )}
              </div>
              {statusBadge}
            </div>
            {/* Info: campaign + device pairing */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flexWrap: "wrap",
                gap: 8,
                padding: "8px 20px 10px",
                borderBottom: "1px solid #f8fafc",
                cursor: "pointer",
              }}
              onClick={() => setSelectedScreen(record)}
            >
              {campaignChip}
              {isPaired === 1 ? (
                /* â”€â”€ PAIRED: status pill + unpair ghost button â”€â”€ */
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      padding: "4px 10px",
                      borderRadius: 20,
                      background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
                      border: "1px solid #93c5fd",
                      fontSize: 12,
                    }}
                  >
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "#3b82f6",
                        boxShadow: "0 0 0 2px #bfdbfe",
                        flexShrink: 0,
                      }}
                    />
                    <OsIcon os={os} size={12} />
                    <span
                      style={{
                        fontWeight: 600,
                        color: "#1d4ed8",
                        letterSpacing: "0.01em",
                      }}
                    >
                      {os}
                      {osVersion ? ` ${osVersion}` : ""}
                    </span>
                    {playerVersion && (
                      <span
                        style={{
                          padding: "1px 6px",
                          borderRadius: 10,
                          background: "#dbeafe",
                          color: "#2563eb",
                          fontSize: 10,
                          fontWeight: 700,
                        }}
                      >
                        v{playerVersion}
                      </span>
                    )}
                  </div>
                  <button
                    onClick={() => onNeedsUnpair(record)}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      padding: "3px 9px",
                      borderRadius: 20,
                      border: "1.5px solid #fca5a5",
                      background: "transparent",
                      color: "#ef4444",
                      fontSize: 11,
                      fontWeight: 600,
                      cursor: "pointer",
                      letterSpacing: "0.01em",
                      lineHeight: 1.4,
                    }}
                  >
                    <DisconnectOutlined style={{ fontSize: 10 }} />
                    {t.menuUnpairTitle || "Unpair"}
                  </button>
                </div>
              ) : (
                /* â”€â”€ UNPAIRED: muted status + pair CTA â”€â”€ */
                <div
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: 6,
                  }}
                >
                  <div
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 5,
                      padding: "4px 10px",
                      borderRadius: 20,
                      background: "transparent",
                      border: "none",
                      fontSize: 12,
                    }}
                  >
                    <span
                      style={{
                        width: 6,
                        height: 6,
                        borderRadius: "50%",
                        background: "#cbd5e1",
                        flexShrink: 0,
                      }}
                    />
                    <Monitor size={11} strokeWidth={2.2} color="#94a3b8" />
                    <span style={{ fontWeight: 500, color: "#94a3b8" }}>
                      {t.notPaired || "No device"}
                    </span>
                  </div>
                  <button
                    disabled={!createPermission}
                    onClick={() => createPermission && onPairScreen(record)}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 4,
                      padding: "3px 11px",
                      borderRadius: 20,
                      border: createPermission
                        ? "1.5px solid #2563eb"
                        : "1.5px solid #e2e8f0",
                      background: createPermission ? "#2563eb" : "#e2e8f0",
                      color: createPermission ? "#fff" : "#94a3b8",
                      fontSize: 11,
                      fontWeight: 700,
                      cursor: createPermission ? "pointer" : "not-allowed",
                      letterSpacing: "0.02em",
                      lineHeight: 1.4,
                      boxShadow: createPermission
                        ? "0 2px 6px rgba(37,99,235,0.25)"
                        : "none",
                    }}
                  >
                    <LinkOutlined style={{ fontSize: 10 }} />
                    {t.pairDevice || "Pair Device"}
                  </button>
                </div>
              )}
            </div>
            {/* Events collapsible */}
            {viewEventPermission && (
              <div style={{ padding: "0 12px" }}>
                <Collapse ghost>
                  <Panel
                    header={
                      <span style={{ fontSize: 13, color: "#64748b" }}>
                        {t.events(screenevents.length)}
                      </span>
                    }
                    key="1"
                  >
                    {eventsContent}
                  </Panel>
                </Collapse>
              </div>
            )}
            {/* Footer: actions + publish */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 16px 12px",
                borderTop: "1px solid #f1f5f9",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                {/* Remote tools group */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    background: "#f8fafc",
                    borderRadius: 8,
                    padding: "2px 4px",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <Popover
                    content={
                      <div style={{ width: 180, padding: "8px" }}>
                        <Row
                          justify="space-between"
                          align="middle"
                          style={{ marginBottom: 8, width: "100%" }}
                        >
                          <Col span={13}>
                            <Slider
                              min={0}
                              max={1}
                              step={0.01}
                              value={
                                tempFormatValues[ScreenCode] ??
                                formatValues[ScreenCode] ??
                                1
                              }
                              onChange={(val) =>
                                setTempFormatValues((prev) => ({
                                  ...prev,
                                  [ScreenCode]: val,
                                }))
                              }
                              tooltip={{
                                formatter: (v) => `${Math.round(v * 100)}%`,
                              }}
                            />
                          </Col>
                          <Col span={8}>
                            <InputNumber
                              min={0}
                              max={1}
                              style={{ width: "100%" }}
                              value={
                                tempFormatValues[ScreenCode] ??
                                formatValues[ScreenCode] ??
                                1
                              }
                              onChange={(val) =>
                                setTempFormatValues((prev) => ({
                                  ...prev,
                                  [ScreenCode]: val,
                                }))
                              }
                            />
                          </Col>
                        </Row>
                        <div style={{ marginTop: 8, textAlign: "right" }}>
                          <Button
                            type="primary"
                            size="small"
                            onClick={() => {
                              const newVal =
                                tempFormatValues[ScreenCode] ??
                                formatValues[ScreenCode] ??
                                1;
                              setFormatValues((prev) => ({
                                ...prev,
                                [ScreenCode]: newVal,
                              }));
                              try {
                                if (firebase && firebase.database) {
                                  const { AccountCode, BrandCode, BranchCode } =
                                    record;
                                  firebase
                                    .database()
                                    .ref(
                                      `${AccountCode}/${BrandCode}/${BranchCode}`,
                                    )
                                    .child(ScreenCode)
                                    .update({ saturation: newVal });
                                }
                              } catch (e) {
                                console.warn("Firebase update failed:", e);
                              }
                              message.success(
                                "Saturation updated successfully",
                              );
                              toggleFormatPopover(null);
                            }}
                          >
                            Save
                          </Button>
                        </div>
                      </div>
                    }
                    title={t.saturationTitle}
                    trigger="click"
                    placement="top"
                    open={formatPopoverVisible === ScreenCode}
                    onOpenChange={() => toggleFormatPopover(ScreenCode)}
                    overlayStyle={{ zIndex: 2000 }}
                  >
                    <Tooltip title="Adjust Saturation">
                      <Button
                        type="text"
                        style={{
                          width: 32,
                          height: 32,
                          padding: 0,
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FormatPainterFilled
                          style={{
                            color: "#1890ff",
                            fontSize: 16,
                            filter: `saturate(${tempFormatValues[ScreenCode] ?? 1})`,
                          }}
                        />
                      </Button>
                    </Tooltip>
                  </Popover>
                  <ActionButton
                    visible={editBrightness}
                    onClicked={() => onEditBrightness(record)}
                    title={t.brightnessManager}
                    showTitle={false}
                    icon="/cms/assets/svgs/icons/brightness_icon.svg"
                  />
                  <ButtonGroup
                    placement="top"
                    vertical={true}
                    title="Player Controls"
                    disabled={!isOnline}
                    items={[
                      <Button
                        id="capture_screen"
                        onClick={() =>
                          onPreRemoteAction(record, "capture_screen")
                        }
                        type="secondary"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_player_screencapture.svg"
                            style={{
                              width: 16,
                              height: "auto",
                              pointerEvents: "none",
                              marginRight: 8,
                            }}
                          />
                        }
                      >
                        {t.captureScreen}
                      </Button>,
                      isPlaying === 1 ? (
                        <Button
                          id="toggle_play"
                          onClick={() =>
                            onPreRemoteAction(record, "toggle_play")
                          }
                          type="secondary"
                          icon={
                            <img
                              src="/cms/assets/svgs/icons/remote_tools/remote_player_stop.svg"
                              style={{
                                width: 16,
                                height: "auto",
                                pointerEvents: "none",
                                marginRight: 8,
                              }}
                            />
                          }
                        >
                          {t.stopPlay}
                        </Button>
                      ) : (
                        <Button
                          id="toggle_play"
                          onClick={() =>
                            onPreRemoteAction(record, "toggle_play")
                          }
                          type="secondary"
                          icon={
                            <img
                              src="/cms/assets/svgs/icons/remote_tools/remote_player_play.svg"
                              style={{
                                width: 16,
                                height: "auto",
                                pointerEvents: "none",
                                marginRight: 8,
                              }}
                            />
                          }
                        >
                          {t.stopPlay}
                        </Button>
                      ),
                      <Button
                        id="reload_player"
                        onClick={() =>
                          onPreRemoteAction(record, "reload_player")
                        }
                        type="secondary"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_player_reload.svg"
                            style={{
                              width: 16,
                              height: "auto",
                              pointerEvents: "none",
                              marginRight: 8,
                            }}
                          />
                        }
                      >
                        {t.reloadPlayer}
                      </Button>,
                    ]}
                  >
                    <Tooltip title={isOnline ? "" : t.playerController}>
                      <Button
                        type="text"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_player.svg"
                            style={{
                              width: 18,
                              height: "auto",
                              opacity: isOnline ? 1 : 0.3,
                            }}
                          />
                        }
                      />
                    </Tooltip>
                  </ButtonGroup>
                  <ButtonGroup
                    placement="top"
                    vertical={true}
                    title="Hardware Controls"
                    disabled={!isOnline}
                    items={[
                      <Button
                        id="reboot_hardware"
                        onClick={() =>
                          onPreRemoteAction(record, "reboot_hardware")
                        }
                        type="secondary"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_hardware_reboot.svg"
                            style={{
                              width: 16,
                              height: "auto",
                              pointerEvents: "none",
                              marginRight: 8,
                            }}
                          />
                        }
                      >
                        {t.rebootHardware}
                      </Button>,
                      <Button
                        id="shutdown_hardware"
                        onClick={() =>
                          onPreRemoteAction(record, "shutdown_hardware")
                        }
                        type="secondary"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_hardware_shutdown.svg"
                            style={{
                              width: 16,
                              height: "auto",
                              pointerEvents: "none",
                              marginRight: 8,
                            }}
                          />
                        }
                      >
                        {t.shutdownHardware}
                      </Button>,
                    ]}
                  >
                    <Tooltip title={isOnline ? "" : t.hardwareController}>
                      <Button
                        type="text"
                        icon={
                          <img
                            src="/cms/assets/svgs/icons/remote_tools/remote_hardware.svg"
                            style={{
                              width: 18,
                              height: "auto",
                              opacity: isOnline ? 1 : 0.3,
                            }}
                          />
                        }
                      />
                    </Tooltip>
                  </ButtonGroup>
                </div>
                {/* end remote tools group */}
                {(editPermission || deletePermission) && (
                  <div
                    style={{
                      width: 1,
                      height: 20,
                      background: "#e2e8f0",
                      flexShrink: 0,
                    }}
                  />
                )}
                {/* Management buttons group */}
                <div style={{ display: "flex", alignItems: "center", gap: 2 }}>
                  {onEditContent && hasLinkedCampaign && (
                    <Tooltip title="Edit playlist content">
                      <button
                        onClick={() => onEditContent(record)}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 4,
                          padding: "4px 10px",
                          borderRadius: 8,
                          border: "1.5px solid #c7d2fe",
                          background: "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                          color: "#4f46e5",
                          fontSize: 11,
                          fontWeight: 600,
                          cursor: "pointer",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <Layers size={12} strokeWidth={2.2} />
                        Edit Content
                      </button>
                    </Tooltip>
                  )}
                  <ActionButton
                    visible={editPermission}
                    onClicked={() => onEdit(record)}
                    title={t.edit}
                    showTitle={false}
                    icon="/cms/assets/svgs/icons/edit_icon.svg"
                  />
                  <ActionButton
                    visible={deletePermission}
                    confirmText={t.deleteConfirm}
                    onClicked={() => onDelete(record)}
                    title={t.delete}
                    showTitle={false}
                    icon="/cms/assets/svgs/icons/trash_icon.svg"
                  />
                  <DisplayDropdown record={record} />
                </div>
              </div>
              <div>{publishBtn}</div>
            </div>
          </div>
          {/* end main content */}
        </motion.div>
      );
    });
  };

  const renderTableDesktop = () => {
    const { selectPage } = parentProps;

    const displayData = sortedData.filter((s) => {
      if (
        localSearch &&
        !s.ScreenName.toLowerCase().includes(localSearch.toLowerCase())
      )
        return false;
      if (
        statusFilter === "online" &&
        (screensStatus[s.ScreenCode]?.is_online ?? 0) !== 1
      )
        return false;
      if (
        statusFilter === "offline" &&
        (screensStatus[s.ScreenCode]?.is_online ?? 0) === 1
      )
        return false;
      if (statusFilter === "pending" && s.PendingPublished !== 1) return false;
      if (locationFilter !== "all") {
        const loc = s.BranchName || s.BranchCode || "";
        if (loc !== locationFilter) return false;
      }
      return true;
    });

    const totalCount = sortedData.length;
    const onlineCount = sortedData.filter(
      (s) => (screensStatus[s.ScreenCode]?.is_online ?? 0) === 1,
    ).length;
    const offlineCount = totalCount - onlineCount;
    const pendingCount = sortedData.filter(
      (s) => s.PendingPublished === 1,
    ).length;
    const uniqueLocations = [
      ...new Set(
        sortedData
          .map((s) => s.BranchName || s.BranchCode || "")
          .filter(Boolean),
      ),
    ];

    const totalPages = Math.max(1, Math.ceil(displayData.length / PAGE_SIZE));
    const safeCurrentPage = Math.min(currentPage, totalPages);
    const pagedData = displayData.slice(
      (safeCurrentPage - 1) * PAGE_SIZE,
      safeCurrentPage * PAGE_SIZE,
    );

    const pendingScreens = sortedData.filter((s) => s.PendingPublished === 1);
    const allOnPage =
      pagedData.length > 0 &&
      pagedData.every((s) => selectedTableRows.includes(s.ScreenID));

    const toggleAll = () => {
      if (allOnPage) {
        setSelectedTableRows((prev) =>
          prev.filter((id) => !pagedData.some((s) => s.ScreenID === id)),
        );
      } else {
        const newIds = pagedData
          .map((s) => s.ScreenID)
          .filter((id) => !selectedTableRows.includes(id));
        setSelectedTableRows((prev) => [...prev, ...newIds]);
      }
    };

    const toggleRow = (id) => {
      setSelectedTableRows((prev) =>
        prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
      );
    };

    const formatTimeAgo = (ts) => {
      if (!ts) return null;
      const diff = Date.now() - (ts > 1e10 ? ts : ts * 1000);
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return "Just now";
      if (mins < 60) return `${mins} min ago`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return `${hrs}h ago`;
      return `${Math.floor(hrs / 24)}d ago`;
    };

    const formatLastSeen = (ts) => {
      if (!ts) return null;
      const d = new Date(ts > 1e10 ? ts : ts * 1000);
      const today = new Date();
      const isToday = d.toDateString() === today.toDateString();
      const timeStr = d.toLocaleTimeString("en-US", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });
      return {
        date: isToday
          ? "Today"
          : d.toLocaleDateString("en-US", { month: "short", day: "numeric" }),
        time: timeStr,
      };
    };

    const colStyle = {
      padding: "10px 12px",
      textAlign: "left",
      fontSize: 11,
      fontWeight: 700,
      color: "#94a3b8",
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      borderBottom: "1px solid #e8ecf3",
      background: "#f8fafc",
    };

    return (
      <div>
        {/* â”€â”€ STATS + SEARCH BAR â”€â”€ */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            border: "1px solid #e8ecf3",
            padding: "16px 24px",
            marginBottom: 16,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 0,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
          }}
        >
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              maxWidth: "600px",
              justifyContent: "space-between",
            }}
          >
            {[
              { label: t.statTotal, value: totalCount, dotColor: null },
              { label: t.online, value: onlineCount, dotColor: "#22c55e" },
              { label: t.offline, value: offlineCount, dotColor: "#94a3b8" },
              {
                label: t.pendingPublish,
                value: pendingCount,
                dotColor: "#f97316",
              },
            ].map((stat, i) => (
              <div
                key={stat.label}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "0 24px",
                  paddingLeft: i === 0 ? 0 : 24,
                  borderLeft: i === 0 ? "none" : "2px solid #f1f5f9",
                }}
              >
                <span
                  style={{
                    fontSize: 12,
                    color: "#94a3b8",
                    fontWeight: 500,
                    whiteSpace: "nowrap",
                  }}
                >
                  {stat.label}
                </span>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 6,
                    marginTop: 4,
                  }}
                >
                  <span
                    style={{
                      fontSize: 24,
                      fontWeight: 700,
                      color: "#0f172a",
                      lineHeight: 1,
                    }}
                    className="stat-value-anim"
                  >
                    {stat.value}
                  </span>
                  {stat.dotColor && (
                    <span
                      className={
                        stat.dotColor === "#22c55e" ? "online-dot-pulse" : ""
                      }
                      style={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        background: stat.dotColor,
                        display: "inline-block",
                      }}
                    />
                  )}
                </div>
              </div>
            ))}
          </div>
          {/* Search + Filters */}
          <div
            style={{
              flex: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "end",
              gap: 10,
              paddingLeft: 24,
              flexWrap: "wrap",
            }}
          >
            <div
              style={{
                flex: 1,
                maxWidth: 300,
                position: "relative",
                minWidth: 160,
              }}
            >
              <Search
                size={14}
                color="#94a3b8"
                style={{
                  position: "absolute",
                  left: 12,
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  zIndex: 1,
                }}
              />
              <input
                value={localSearch}
                onChange={(e) => {
                  setLocalSearch(e.target.value);
                  setCurrentPage(1);
                }}
                placeholder={t.searchPlaceholder}
                style={{
                  width: "100%",
                  height: 38,
                  borderRadius: 10,
                  border: "1px solid #e2e8f0",
                  paddingLeft: 36,
                  paddingRight: 12,
                  fontSize: 13,
                  color: "#0f172a",
                  outline: "none",
                  background: "#f8fafc",
                  boxSizing: "border-box",
                }}
              />
            </div>

            <Select
              value={locationFilter}
              onChange={(val) => {
                setLocationFilter(val);
                setCurrentPage(1);
                onLocationChange(val === "all" ? null : val);
              }}
              size="large"
              style={{ minWidth: 140 }}
            >
              <Select.Option value="all">{t.allLocations}</Select.Option>
              {uniqueLocations.map((loc) => (
                <Select.Option key={loc} value={loc}>
                  {loc}
                </Select.Option>
              ))}
            </Select>

            <Select
              value={statusFilter}
              onChange={(val) => {
                setStatusFilter(val);
                setCurrentPage(1);
              }}
              size="large"
              style={{ minWidth: 130 }}
            >
              <Select.Option value="all">{t.allStatus}</Select.Option>
              <Select.Option value="online">{t.online}</Select.Option>
              <Select.Option value="offline">{t.offline}</Select.Option>
              <Select.Option value="pending">{t.pendingPublish}</Select.Option>
            </Select>
          </div>
        </div>

        {/* â”€â”€ TABLE CARD â”€â”€ */}
        <div
          style={{
            background: "#fff",
            borderRadius: 16,
            border: "1px solid #e8ecf3",
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            overflow: "hidden",
          }}
        >
          {/* Table controls: count + view toggle */}
          {displayData.length > 0 && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "14px 20px",
                borderBottom: "1px solid #f1f5f9",
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span
                  style={{ fontSize: 13, color: "#64748b", fontWeight: 500 }}
                >
                  {displayData.length} screens
                </span>
                <div style={{ display: "flex", gap: 3 }}>
                  <button
                    onClick={() => setViewMode("grid")}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 7,
                      border: "1px solid #e2e8f0",
                      background: viewMode === "grid" ? "#eef2ff" : "#f8fafc",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: viewMode === "grid" ? "#6366f1" : "#94a3b8",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="currentColor"
                    >
                      <rect x="0.5" y="0.5" width="5.5" height="5.5" rx="1.5" />
                      <rect
                        x="8"
                        y="0.5"
                        width="5.5"
                        height="5.5"
                        rx="1.5"
                        opacity={viewMode === "grid" ? 1 : 0.35}
                      />
                      <rect
                        x="0.5"
                        y="8"
                        width="5.5"
                        height="5.5"
                        rx="1.5"
                        opacity={viewMode === "grid" ? 1 : 0.35}
                      />
                      <rect
                        x="8"
                        y="8"
                        width="5.5"
                        height="5.5"
                        rx="1.5"
                        opacity={viewMode === "grid" ? 1 : 0.35}
                      />
                    </svg>
                  </button>
                  <button
                    onClick={() => setViewMode("list")}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 7,
                      border: "1px solid #e2e8f0",
                      background: viewMode === "list" ? "#eef2ff" : "#f8fafc",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: viewMode === "list" ? "#6366f1" : "#94a3b8",
                    }}
                  >
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 14 14"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                    >
                      <line x1="2" y1="3.5" x2="12" y2="3.5" />
                      <line x1="2" y1="7" x2="12" y2="7" />
                      <line x1="2" y1="10.5" x2="12" y2="10.5" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* Table / Grid body */}
          {displayData.length === 0 ? (
            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
              style={{ padding: "48px 20px" }}
            >
              {renderNoScreensState()}
            </motion.div>
          ) : viewMode === "grid" ? (
            /* â”€â”€ GRID VIEW â”€â”€ */
            <motion.div
              key="grid"
              className="screen-view-body"
              variants={Animations.LIST_CONTAINER}
              initial="hidden"
              animate="show"
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                gap: 16,
                padding: 20,
              }}
            >
              {pagedData.map((record) => {
                const {
                  ScreenCode,
                  ScreenName,
                  CampaignName,
                  CampaignID,
                  PendingPublished = 0,
                  ScreenID,
                } = record;

                const statusData = screensStatus[ScreenCode] || {};
                const isOnline = statusData.is_online ?? 0;
                const os = statusData.os ?? "";
                const osVersion = statusData.os_version ?? "";
                const playerVersion = statusData.player_version ?? null;

                const licenseActive = !CHECK_LICENSE
                  ? true
                  : "LicenseStatus" in record
                    ? record.LicenseStatus === "active"
                    : false;

                const isSelected = selectedTableRows.includes(ScreenID);
                const displayId = ScreenCode || String(ScreenID);

                const formatTimeAgoLocal = (ts) => {
                  if (!ts) return null;
                  const diff = Date.now() - (ts > 1e10 ? ts : ts * 1000);
                  const mins = Math.floor(diff / 60000);
                  if (mins < 1) return "Just now";
                  if (mins < 60) return `${mins} min ago`;
                  const hrs = Math.floor(mins / 60);
                  if (hrs < 24) return `${hrs}h ago`;
                  return `${Math.floor(hrs / 24)}d ago`;
                };

                let publishActionBtn = null;
                if (allowPublishPermission) {
                  if (!licenseActive) {
                    publishActionBtn = (
                      <Button
                        size="small"
                        onClick={() =>
                          selectPage && selectPage(Constants.LICENSE_PAGE)
                        }
                        disabled
                        style={{
                          borderRadius: 6,
                          fontSize: 12,
                          fontWeight: 600,
                          height: 30,
                          flex: 1,
                        }}
                      >
                        {t.manageLicense}
                      </Button>
                    );
                  } else if (!CampaignID || CampaignID === "") {
                    publishActionBtn = (
                      <Button
                        disabled
                        size="small"
                        style={{
                          borderRadius: 6,
                          fontSize: 12,
                          height: 30,
                          flex: 1,
                        }}
                      >
                        {t.publish}
                      </Button>
                    );
                  } else {
                    const title = isOnline
                      ? t.publishInstant
                      : t.publishWhenOnline;
                    publishActionBtn = (
                      <Popconfirm
                        title={title}
                        onConfirm={() => onPublish(record)}
                        okText={t.publish}
                        cancelText={t.cancel}
                      >
                        <Button
                          size="small"
                          type="primary"
                          style={{
                            borderRadius: 6,
                            fontSize: 12,
                            fontWeight: 600,
                            height: 30,
                            flex: 1,
                            background:
                              PendingPublished === 1
                                ? "linear-gradient(135deg,#f97316,#ea580c)"
                                : "linear-gradient(135deg,#6366f1,#4f46e5)",
                            borderColor:
                              PendingPublished === 1 ? "#ea580c" : "#4f46e5",
                          }}
                        >
                          {t.publish}
                        </Button>
                      </Popconfirm>
                    );
                  }
                }

                return (
                  <motion.div
                    key={ScreenCode || ScreenID}
                    variants={Animations.LIST_ITEM}
                    whileHover={{ y: -4 }}
                    whileTap={{ scale: 0.98 }}
                    className="screen-grid-card"
                    onMouseEnter={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 4px 14px rgba(99,102,241,0.10)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.boxShadow =
                        "0 1px 4px rgba(0,0,0,0.06)";
                    }}
                    style={{
                      background: isSelected ? "#f5f3ff" : "#fff",
                      border: isSelected
                        ? "1.5px solid #a5b4fc"
                        : PendingPublished === 1
                          ? "1.5px solid #fed7aa"
                          : "1px solid #e8ecf3",
                      borderRadius: 16,
                      overflow: "hidden",
                      boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
                      display: "flex",
                      flexDirection: "column",
                      transition: "box-shadow 0.2s ease",
                      cursor: "pointer",
                    }}
                    onClick={() => setSelectedScreen(record)}
                  >
                    {/* Card header */}
                    <div
                      style={{
                        padding: "14px 16px 12px",
                        borderBottom: "1px solid #f1f5f9",
                        display: "flex",
                        alignItems: "flex-start",
                        gap: 12,
                      }}
                    >
                      {/* Checkbox */}
                      <Checkbox
                        checked={isSelected}
                        onChange={(e) => {
                          e.stopPropagation();
                          toggleRow(ScreenID);
                        }}
                        onClick={(e) => e.stopPropagation()}
                        style={{ marginTop: 2, flexShrink: 0 }}
                      />
                      {/* Screen icon */}
                      <div
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: 11,
                          background:
                            PendingPublished === 1
                              ? "linear-gradient(135deg,#fff7ed,#ffedd5)"
                              : "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexShrink: 0,
                        }}
                      >
                        <MonitorPlay
                          size={18}
                          color={PendingPublished === 1 ? "#f97316" : "#6366f1"}
                        />
                      </div>
                      {/* Name + ID */}
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div
                          style={{
                            fontWeight: 700,
                            fontSize: 14,
                            color: "#0f172a",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {ScreenName}
                        </div>
                        <div
                          style={{
                            fontSize: 11,
                            color: "#94a3b8",
                            marginTop: 2,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          ID: {displayId}
                        </div>
                      </div>
                      {/* Online badge */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 4,
                          flexShrink: 0,
                        }}
                      >
                        <span
                          className={isOnline === 1 ? "online-dot-pulse" : ""}
                          style={{
                            width: 7,
                            height: 7,
                            borderRadius: "50%",
                            background: isOnline === 1 ? "#22c55e" : "#94a3b8",
                            display: "inline-block",
                          }}
                        />
                        <span
                          style={{
                            fontSize: 11,
                            fontWeight: 600,
                            color: isOnline === 1 ? "#15803d" : "#64748b",
                          }}
                        >
                          {isOnline === 1 ? t.online : t.offline}
                        </span>
                      </div>
                    </div>

                    {/* Card body */}
                    <div style={{ padding: "12px 16px", flex: 1 }}>
                      {/* Campaign */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: 6,
                          marginBottom: 8,
                        }}
                      >
                        {CampaignName ? (
                          <button
                            onClick={() =>
                              viewCampaignPermission &&
                              onCampaignClicked(record)
                            }
                            style={{
                              background: "#fff",
                              border: "1px dashed #cbd5e1",
                              borderRadius: 20,
                              padding: "3px 10px",
                              fontSize: 12,
                              fontWeight: 500,
                              color: viewCampaignPermission
                                ? "#334155"
                                : "#94a3b8",
                              cursor: viewCampaignPermission
                                ? "pointer"
                                : "not-allowed",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              width: 200,
                              textAlign: "center",
                              display: "block",
                              transition:
                                "border-color 0.15s, background 0.15s",
                            }}
                            onMouseEnter={(e) => {
                              if (viewCampaignPermission) {
                                e.currentTarget.style.borderColor = "#94a3b8";
                                e.currentTarget.style.borderStyle = "solid";
                                e.currentTarget.style.background = "#f8fafc";
                                e.currentTarget.style.color = "#2563eb";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.borderColor = "#cbd5e1";
                              e.currentTarget.style.borderStyle = "dashed";
                              e.currentTarget.style.background = "#fff";
                              e.currentTarget.style.color = "#334155";
                            }}
                          >
                            {CampaignName}
                          </button>
                        ) : (
                          <span
                            style={{
                              fontSize: 12,
                              color: "#94a3b8",
                              fontStyle: "italic",
                            }}
                          >
                            {t.noCampaign}
                          </span>
                        )}
                      </div>

                      {/* Player info */}
                      {(os || playerVersion) && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 6,
                            marginBottom: 8,
                          }}
                        >
                          <OsIcon os={os} size={13} />
                          <span style={{ fontSize: 12, color: "#64748b" }}>
                            {os}
                            {osVersion ? ` ${osVersion}` : ""}
                          </span>
                          {playerVersion && (
                            <span
                              style={{
                                fontSize: 10,
                                fontWeight: 700,
                                color: "#16a34a",
                                background: "#dcfce7",
                                borderRadius: 8,
                                padding: "1px 6px",
                              }}
                            >
                              v{playerVersion}
                            </span>
                          )}
                        </div>
                      )}

                      {/* Publish status */}
                      {CampaignID && CampaignID !== "" && (
                        <div style={{ marginTop: 4 }}>
                          {PendingPublished === 1 ? (
                            <span
                              style={{
                                display: "inline-block",
                                padding: "2px 9px",
                                borderRadius: 20,
                                background: "#fff7ed",
                                color: "#c2410c",
                                border: "1px solid #fed7aa",
                                fontSize: 11,
                                fontWeight: 700,
                              }}
                            >
                              Pending Changes
                            </span>
                          ) : (
                            <span
                              style={{
                                display: "inline-block",
                                padding: "2px 9px",
                                borderRadius: 20,
                                background: "#f0fdf4",
                                color: "#15803d",
                                border: "1px solid #bbf7d0",
                                fontSize: 11,
                                fontWeight: 700,
                              }}
                            >
                              Published
                            </span>
                          )}
                        </div>
                      )}
                    </div>

                    {/* Card footer: actions */}
                    <div
                      style={{
                        padding: "10px 16px",
                        borderTop: "1px solid #f1f5f9",
                        display: "flex",
                        alignItems: "center",
                        gap: 6,
                        background: "#fafbfc",
                      }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      {editPermission && (
                        <Tooltip title={t.edit}>
                          <motion.button
                            onClick={() => onEdit(record)}
                            whileHover={{
                              scale: 1.12,
                              backgroundColor: "#eef2ff",
                            }}
                            whileTap={{ scale: 0.92 }}
                            style={{
                              width: 30,
                              height: 30,
                              borderRadius: 7,
                              border: "1px solid #e2e8f0",
                              background: "#fff",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <img
                              src="/cms/assets/svgs/icons/edit_icon.svg"
                              style={{ width: 14, height: 14 }}
                              alt="edit"
                            />
                          </motion.button>
                        </Tooltip>
                      )}
                      <div style={{ flex: 1 }}>{publishActionBtn}</div>
                      {onEditContent && !!(CampaignID && CampaignID !== "") && (
                        <Tooltip title="Edit playlist content">
                          <button
                            onClick={() => onEditContent(record)}
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 4,
                              padding: "4px 10px",
                              borderRadius: 8,
                              border: "1.5px solid #c7d2fe",
                              background:
                                "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                              color: "#4f46e5",
                              fontSize: 11,
                              fontWeight: 600,
                              cursor: "pointer",
                              whiteSpace: "nowrap",
                            }}
                          >
                            <Layers size={12} strokeWidth={2.2} />
                            Edit Content
                          </button>
                        </Tooltip>
                      )}
                      <DisplayDropdown record={record} />
                      <Popover
                        content={getMenu(record, () =>
                          setOpenPopoverCode(null),
                        )}
                        trigger="click"
                        placement={actionPlacement}
                        open={openPopoverCode === ScreenCode}
                        onOpenChange={(v) => {
                          if (!v) setOpenPopoverCode(null);
                        }}
                        overlayInnerStyle={{
                          padding: 0,
                          borderRadius: 16,
                          boxShadow: "none",
                        }}
                      >
                        <motion.button
                          onClick={(e) => {
                            computeActionPlacement(e.currentTarget);
                            setOpenPopoverCode(ScreenCode);
                          }}
                          whileHover={{
                            scale: 1.12,
                            backgroundColor: "#f1f5f9",
                          }}
                          whileTap={{ scale: 0.92 }}
                          style={{
                            width: 30,
                            height: 30,
                            borderRadius: 7,
                            border: "1px solid #e2e8f0",
                            background: "#fff",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#64748b",
                            fontSize: 16,
                            letterSpacing: 1,
                            lineHeight: 1,
                          }}
                        >
                          <MoreOutlined style={{ fontSize: 16 }} />
                        </motion.button>
                      </Popover>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
          ) : (
            /* â”€â”€ LIST / TABLE VIEW â”€â”€ */
            <motion.div
              key="list"
              className="screen-view-body"
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.22, ease: [0.25, 0.46, 0.45, 0.94] }}
              style={{ overflowX: "auto" }}
            >
              <table
                style={{
                  width: "100%",
                  borderCollapse: "collapse",
                  minWidth: 860,
                }}
              >
                <thead>
                  <tr>
                    <th style={{ ...colStyle, width: 52 }}>
                      <Checkbox checked={allOnPage} onChange={toggleAll} />
                    </th>
                    <th
                      style={{
                        ...colStyle,
                        minWidth: 190,
                        cursor: "pointer",
                        userSelect: "none",
                        color: sortBy === "name" ? "#6366f1" : undefined,
                      }}
                      onClick={() => handleSort("name")}
                    >
                      <span
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        {t.colScreen}
                        <SortCarets field="name" />
                      </span>
                    </th>
                    <th
                      style={{
                        ...colStyle,
                        minWidth: 115,
                        textAlign: "center",
                        cursor: "pointer",
                        userSelect: "none",
                        color: sortBy === "online" ? "#6366f1" : undefined,
                      }}
                      onClick={() => handleSort("online")}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {t.colStatus}
                        <SortCarets field="online" />
                      </span>
                    </th>
                    <th
                      style={{
                        ...colStyle,
                        minWidth: 165,
                        textAlign: "center",
                        cursor: "pointer",
                        userSelect: "none",
                        color: sortBy === "campaign" ? "#6366f1" : undefined,
                      }}
                      onClick={() => handleSort("campaign")}
                    >
                      <span
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {t.colContent}
                        <SortCarets field="campaign" />
                      </span>
                    </th>
                    <th style={{ ...colStyle, minWidth: 135 }}>
                      {t.colPlayer}
                    </th>
                    <th
                      style={{
                        ...colStyle,
                        minWidth: 100,
                        textAlign: "center",
                      }}
                    >
                      {t.colPairing}
                    </th>
                    <th style={{ ...colStyle, minWidth: 110 }}>
                      {t.colLastSeen}
                    </th>
                    <th
                      style={{
                        ...colStyle,
                        minWidth: 145,
                        cursor: "pointer",
                        userSelect: "none",
                        color: sortBy === "pending" ? "#6366f1" : undefined,
                      }}
                      onClick={() => handleSort("pending")}
                    >
                      <span
                        style={{ display: "inline-flex", alignItems: "center" }}
                      >
                        {t.sortPending}
                        <SortCarets field="pending" />
                      </span>
                    </th>
                    <th style={{ ...colStyle, minWidth: 155 }}>
                      {t.colActions}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {pagedData.map((record, idx) => {
                    const {
                      ScreenCode,
                      ScreenName,
                      CampaignName,
                      CampaignID,
                      PendingPublished = 0,
                      ScreenID,
                    } = record;

                    const statusData = screensStatus[ScreenCode] || {};
                    const isOnline = statusData.is_online ?? 0;
                    const isPaired = !!statusData.is_paired;
                    const os = statusData.os ?? "";
                    const osVersion = statusData.os_version ?? "";
                    const playerVersion = statusData.player_version ?? null;
                    const lastOnlineTs = statusData.last_online_ts ?? null;

                    const licenseActive = !CHECK_LICENSE
                      ? true
                      : "LicenseStatus" in record
                        ? record.LicenseStatus === "active"
                        : false;

                    const isSelected = selectedTableRows.includes(ScreenID);
                    const displayId = ScreenCode || String(ScreenID);

                    const statusTimeAgo = formatTimeAgo(lastOnlineTs);
                    const lastSeenData = formatLastSeen(lastOnlineTs);

                    // Publish status badge
                    let publishBadgeEl = null;
                    let publishTimeAgo = null;
                    if (!CampaignID || CampaignID === "") {
                      publishBadgeEl = null;
                    } else if (PendingPublished === 1) {
                      publishBadgeEl = (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "3px 10px",
                            borderRadius: 20,
                            background: "#fff7ed",
                            color: "#c2410c",
                            border: "1px solid #fed7aa",
                            fontSize: 11,
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Pending Changes
                        </span>
                      );
                      publishTimeAgo = record.PendingPublishedAt
                        ? formatTimeAgo(record.PendingPublishedAt)
                        : null;
                    } else {
                      publishBadgeEl = (
                        <span
                          style={{
                            display: "inline-block",
                            padding: "3px 10px",
                            borderRadius: 20,
                            background: "#f0fdf4",
                            color: "#15803d",
                            border: "1px solid #bbf7d0",
                            fontSize: 11,
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                          }}
                        >
                          Published
                        </span>
                      );
                      publishTimeAgo = record.PublishedAt
                        ? formatTimeAgo(record.PublishedAt)
                        : null;
                    }

                    // Publish action button
                    let publishActionBtn = null;
                    if (allowPublishPermission) {
                      if (!licenseActive) {
                        publishActionBtn = (
                          <Button
                            size="small"
                            onClick={() =>
                              selectPage && selectPage(Constants.LICENSE_PAGE)
                            }
                            style={{
                              borderRadius: 6,
                              fontSize: 12,
                              fontWeight: 600,
                              borderColor: "#a855f7",
                              color: "#a855f7",
                              height: 30,
                            }}
                          >
                            {t.manageLicense}
                          </Button>
                        );
                      } else if (!CampaignID || CampaignID === "") {
                        publishActionBtn = (
                          <Button
                            disabled
                            size="small"
                            style={{
                              borderRadius: 6,
                              fontSize: 12,
                              height: 30,
                            }}
                          >
                            {t.publish}
                          </Button>
                        );
                      } else {
                        const title = isOnline
                          ? t.publishInstant
                          : t.publishWhenOnline;
                        publishActionBtn = (
                          <Popconfirm
                            title={title}
                            onConfirm={() => onPublish(record)}
                            okText={t.publish}
                            cancelText={t.cancel}
                          >
                            <Button
                              size="small"
                              type="primary"
                              style={{
                                borderRadius: 6,
                                fontSize: 12,
                                fontWeight: 600,
                                height: 30,
                                background:
                                  PendingPublished === 1
                                    ? "linear-gradient(135deg,#f97316,#ea580c)"
                                    : "linear-gradient(135deg,#6366f1,#4f46e5)",
                                borderColor:
                                  PendingPublished === 1
                                    ? "#ea580c"
                                    : "#4f46e5",
                              }}
                            >
                              {t.publish}
                            </Button>
                          </Popconfirm>
                        );
                      }
                    }

                    return (
                      <motion.tr
                        key={ScreenCode || ScreenID}
                        className={`screen-table-row${isSelected ? " screen-row-selected" : ""}`}
                        initial={{ opacity: 0, x: -8 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{
                          duration: 0.25,
                          delay: idx * 0.04,
                          ease: [0.25, 0.46, 0.45, 0.94],
                        }}
                        style={{
                          background: isSelected ? "#f5f3ff" : "#fff",
                          borderBottom: "1px solid #f1f5f9",
                          cursor: "pointer",
                        }}
                        onClick={() => setSelectedScreen(record)}
                        onHoverStart={(e) => {
                          if (!isSelected)
                            e.target.style &&
                              (e.target.style.background = "#f8faff");
                        }}
                        onHoverEnd={(e) => {
                          if (!isSelected)
                            e.target.style &&
                              (e.target.style.background = "#fff");
                        }}
                      >
                        {/* Checkbox */}
                        <td
                          style={{ padding: "14px 16px" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Checkbox
                            checked={isSelected}
                            onChange={() => toggleRow(ScreenID)}
                          />
                        </td>

                        {/* SCREEN */}
                        <td style={{ padding: "12px 12px" }}>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 10,
                            }}
                          >
                            <div
                              style={{
                                width: 38,
                                height: 38,
                                borderRadius: 10,
                                background:
                                  "linear-gradient(135deg, #eef2ff, #e0e7ff)",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexShrink: 0,
                              }}
                            >
                              <MonitorPlay size={17} color="#6366f1" />
                            </div>
                            <div style={{ minWidth: 0 }}>
                              <div
                                style={{
                                  fontWeight: 700,
                                  fontSize: 13,
                                  color: "#0f172a",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  maxWidth: 160,
                                  cursor: "pointer",
                                }}
                                onClick={() => setSelectedScreen(record)}
                              >
                                {ScreenName}
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 4,
                                  marginTop: 2,
                                }}
                              >
                                <span
                                  style={{
                                    fontSize: 11,
                                    color: "#94a3b8",
                                    maxWidth: 130,
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  ID: {displayId}
                                </span>
                                <Tooltip title="Copy screen code">
                                  <button
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      if (navigator.clipboard) {
                                        navigator.clipboard.writeText(
                                          displayId,
                                        );
                                        message.success("Copied!");
                                      }
                                    }}
                                    style={{
                                      background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      padding: 0,
                                      color: "#94a3b8",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Copy size={11} />
                                  </button>
                                </Tooltip>
                              </div>
                            </div>
                          </div>
                        </td>

                        {/* STATUS */}
                        <td
                          style={{ padding: "12px 12px", textAlign: "center" }}
                        >
                          <div>
                            <div
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 5,
                              }}
                            >
                              <span
                                className={
                                  isOnline === 1 ? "online-dot-pulse" : ""
                                }
                                style={{
                                  width: 7,
                                  height: 7,
                                  borderRadius: "50%",
                                  background:
                                    isOnline === 1 ? "#22c55e" : "#94a3b8",
                                  flexShrink: 0,
                                }}
                              />
                              <span
                                style={{
                                  fontSize: 13,
                                  fontWeight: 600,
                                  color: isOnline === 1 ? "#15803d" : "#64748b",
                                }}
                              >
                                {isOnline === 1 ? t.online : t.offline}
                              </span>
                            </div>
                            {statusTimeAgo && (
                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#94a3b8",
                                  marginTop: 2,
                                }}
                              >
                                {statusTimeAgo}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* CONTENT */}
                        <td
                          style={{ padding: "12px 12px", textAlign: "center" }}
                        >
                          <div>
                            {CampaignName ? (
                              <button
                                onClick={() =>
                                  viewCampaignPermission &&
                                  onCampaignClicked(record)
                                }
                                style={{
                                  background: "#fff",
                                  border: "1px dashed #cbd5e1",
                                  borderRadius: 20,
                                  padding: "4px 12px",
                                  fontSize: 13,
                                  fontWeight: 500,
                                  color: viewCampaignPermission
                                    ? "#334155"
                                    : "#94a3b8",
                                  cursor: viewCampaignPermission
                                    ? "pointer"
                                    : "not-allowed",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  width: 200,
                                  textAlign: "center",
                                  display: "inline-block",
                                  transition:
                                    "border-color 0.15s, background 0.15s",
                                }}
                                onMouseEnter={(e) => {
                                  if (viewCampaignPermission) {
                                    e.currentTarget.style.borderColor =
                                      "#94a3b8";
                                    e.currentTarget.style.borderStyle = "solid";
                                    e.currentTarget.style.background =
                                      "#f8fafc";
                                    e.currentTarget.style.color = "#2563eb";
                                  }
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.borderColor = "#cbd5e1";
                                  e.currentTarget.style.borderStyle = "dashed";
                                  e.currentTarget.style.background = "#fff";
                                  e.currentTarget.style.color = "#334155";
                                }}
                              >
                                {CampaignName}
                              </button>
                            ) : (
                              <span
                                style={{
                                  fontSize: 13,
                                  color: "#94a3b8",
                                  fontStyle: "italic",
                                }}
                              >
                                {t.noCampaign}
                              </span>
                            )}
                            {record.UpdatedAt && (
                              <div
                                style={{
                                  fontSize: 11,
                                  color: "#94a3b8",
                                  marginTop: 4,
                                }}
                              >
                                Updated {formatTimeAgo(record.UpdatedAt)}
                              </div>
                            )}
                          </div>
                        </td>

                        {/* PLAYER */}
                        <td style={{ padding: "12px 12px" }}>
                          {os || playerVersion ? (
                            <div
                              style={{
                                display: "flex",
                                alignItems: "flex-start",
                                gap: 7,
                              }}
                            >
                              <OsIcon os={os} />
                              <div>
                                <div
                                  style={{
                                    fontSize: 12,
                                    fontWeight: 600,
                                    color: "#0f172a",
                                    whiteSpace: "nowrap",
                                  }}
                                >
                                  {os}
                                  {osVersion ? ` ${osVersion}` : ""}
                                </div>
                                {playerVersion && (
                                  <div
                                    style={{
                                      display: "inline-block",
                                      fontSize: 10,
                                      fontWeight: 700,
                                      color: "#16a34a",
                                      background: "#dcfce7",
                                      borderRadius: 8,
                                      padding: "1px 6px",
                                      marginTop: 2,
                                    }}
                                  >
                                    v{playerVersion}
                                  </div>
                                )}
                              </div>
                            </div>
                          ) : (
                            <span style={{ fontSize: 12, color: "#94a3b8" }}>
                              —
                            </span>
                          )}
                        </td>

                        {/* PAIRING */}
                        <td
                          style={{ padding: "12px 12px", textAlign: "center" }}
                        >
                          {isPaired ? (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "3px 10px",
                                borderRadius: 20,
                                fontSize: 11,
                                fontWeight: 600,
                                background: "#eff6ff",
                                color: "#1d4ed8",
                                border: "1px solid #bfdbfe",
                              }}
                            >
                              <span
                                style={{
                                  width: 6,
                                  height: 6,
                                  borderRadius: "50%",
                                  background: "#3b82f6",
                                  flexShrink: 0,
                                }}
                              />
                              {t.paired || "Paired"}
                            </span>
                          ) : createPermission ? (
                            <Tooltip
                              title={
                                t.pairDeviceHint ||
                                "Connect this screen to a new device"
                              }
                            >
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  onPairScreen(record);
                                }}
                                style={{
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 5,
                                  padding: "4px 12px",
                                  borderRadius: 20,
                                  border: "1.5px solid #2563eb",
                                  background: "#2563eb",
                                  color: "#fff",
                                  fontSize: 11,
                                  fontWeight: 700,
                                  cursor: "pointer",
                                  letterSpacing: "0.02em",
                                  lineHeight: 0.85,
                                  boxShadow: "0 2px 6px rgba(37,99,235,0.25)",
                                }}
                              >
                                <LinkOutlined style={{ fontSize: 12 }} />
                                {t.pairDevice || "Pair Device"}
                              </button>
                            </Tooltip>
                          ) : (
                            <span
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: 5,
                                padding: "3px 10px",
                                borderRadius: 20,
                                fontSize: 11,
                                fontWeight: 600,
                                background: "#f8fafc",
                                color: "#94a3b8",
                                border: "1px solid #e2e8f0",
                              }}
                            >
                              <span
                                style={{
                                  width: 6,
                                  height: 6,
                                  borderRadius: "50%",
                                  background: "#cbd5e1",
                                  flexShrink: 0,
                                }}
                              />
                              {t.notPaired || "Not Paired"}
                            </span>
                          )}
                        </td>

                        {/* LAST SEEN */}
                        <td style={{ padding: "12px 12px" }}>
                          {lastSeenData ? (
                            <div>
                              <div
                                style={{
                                  fontSize: 12,
                                  fontWeight: 600,
                                  color: "#0f172a",
                                }}
                              >
                                {lastSeenData.date}
                              </div>
                              <div style={{ fontSize: 11, color: "#94a3b8" }}>
                                {lastSeenData.time}
                              </div>
                            </div>
                          ) : (
                            <span style={{ fontSize: 12, color: "#94a3b8" }}>
                              —
                            </span>
                          )}
                        </td>

                        {/* PUBLISH STATUS */}
                        <td style={{ padding: "12px 12px" }}>
                          {publishBadgeEl ? (
                            <div>
                              {publishBadgeEl}
                              {publishTimeAgo && (
                                <div
                                  style={{
                                    fontSize: 11,
                                    color: "#94a3b8",
                                    marginTop: 4,
                                  }}
                                >
                                  {publishTimeAgo}
                                </div>
                              )}
                            </div>
                          ) : (
                            <span style={{ fontSize: 12, color: "#94a3b8" }}>
                              —
                            </span>
                          )}
                        </td>

                        {/* ACTIONS */}
                        <td
                          style={{ padding: "12px 12px" }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: 6,
                            }}
                          >
                            {editPermission && (
                              <Tooltip title={t.edit}>
                                <button
                                  onClick={() => onEdit(record)}
                                  style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: 7,
                                    border: "1px solid #e2e8f0",
                                    background: "#f8fafc",
                                    cursor: "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "#64748b",
                                  }}
                                >
                                  <img
                                    src="/cms/assets/svgs/icons/edit_icon.svg"
                                    style={{ width: 14, height: 14 }}
                                    alt="edit"
                                  />
                                </button>
                              </Tooltip>
                            )}
                            {publishActionBtn}
                            {onEditContent &&
                              !!(CampaignID && CampaignID !== "") && (
                                <Tooltip title="Edit playlist content">
                                  <button
                                    onClick={() => onEditContent(record)}
                                    style={{
                                      display: "inline-flex",
                                      alignItems: "center",
                                      gap: 4,
                                      padding: "4px 10px",
                                      borderRadius: 8,
                                      border: "1.5px solid #c7d2fe",
                                      background:
                                        "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                                      color: "#4f46e5",
                                      fontSize: 11,
                                      fontWeight: 600,
                                      cursor: "pointer",
                                      whiteSpace: "nowrap",
                                    }}
                                  >
                                    <Layers size={12} strokeWidth={2.2} />
                                    Edit Content
                                  </button>
                                </Tooltip>
                              )}
                            <DisplayDropdown record={record} />
                            <Popover
                              content={getMenu(record, () =>
                                setOpenPopoverCode(null),
                              )}
                              trigger="click"
                              placement={actionPlacement}
                              open={openPopoverCode === ScreenCode}
                              onOpenChange={(v) => {
                                if (!v) setOpenPopoverCode(null);
                              }}
                              overlayInnerStyle={{
                                padding: 0,
                                borderRadius: 16,
                                boxShadow: "none",
                              }}
                            >
                              <button
                                onClick={(e) => {
                                  computeActionPlacement(e.currentTarget);
                                  setOpenPopoverCode(ScreenCode);
                                }}
                                style={{
                                  width: 30,
                                  height: 30,
                                  borderRadius: 7,
                                  border: "1px solid #e2e8f0",
                                  background: "#f8fafc",
                                  cursor: "pointer",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  color: "#64748b",
                                  fontSize: 16,
                                  letterSpacing: 1,
                                  lineHeight: 1,
                                }}
                              >
                                <MoreOutlined style={{ fontSize: 16 }} />
                              </button>
                            </Popover>
                          </div>
                        </td>
                      </motion.tr>
                    );
                  })}
                </tbody>
              </table>
            </motion.div>
          )}

          {/* Pagination */}
          <div
            style={{
              padding: "12px 20px",
              borderTop: "1px solid #f1f5f9",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontSize: 13, color: "#64748b" }}>
              {displayData.length === 0
                ? t.noScreensFound
                : t.showingRange(
                    (safeCurrentPage - 1) * PAGE_SIZE + 1,
                    Math.min(safeCurrentPage * PAGE_SIZE, displayData.length),
                    displayData.length,
                  )}
            </span>
            <Pagination
              current={safeCurrentPage}
              pageSize={PAGE_SIZE}
              total={displayData.length}
              onChange={(p) => setCurrentPage(p)}
              showSizeChanger={false}
              size="small"
            />
          </div>
        </div>

        {/* â”€â”€ BULK ACTION BAR â”€â”€ */}
        {pendingScreens.length > 0 &&
          (() => {
            // screens to act on: selected-and-pending if any are selected, else all pending
            const selectedPending = pendingScreens.filter((s) =>
              selectedTableRows.includes(s.ScreenID),
            );
            const targetScreens =
              selectedTableRows.length > 0 ? selectedPending : pendingScreens;
            const targetCount = targetScreens.length;
            const hasSelection = selectedTableRows.length > 0;
            const allPendingSelected = pendingScreens.every((s) =>
              selectedTableRows.includes(s.ScreenID),
            );

            return (
              <div
                style={{
                  marginTop: 16,
                  background: "#fff",
                  borderRadius: 14,
                  border: "1px solid #e8ecf3",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
                  padding: "14px 20px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 16,
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <Checkbox
                    checked={allPendingSelected}
                    onChange={() => {
                      const ids = pendingScreens.map((s) => s.ScreenID);
                      if (allPendingSelected) {
                        setSelectedTableRows((prev) =>
                          prev.filter((id) => !ids.includes(id)),
                        );
                      } else {
                        setSelectedTableRows((prev) => [
                          ...new Set([...prev, ...ids]),
                        ]);
                      }
                    }}
                  />
                  <span
                    style={{ fontSize: 13, fontWeight: 600, color: "#0f172a" }}
                  >
                    {t.unpublishedChanges(pendingScreens.length)}
                  </span>
                  <button
                    onClick={() => {
                      if (allPendingSelected) {
                        setSelectedTableRows((prev) =>
                          prev.filter(
                            (id) =>
                              !pendingScreens.some((s) => s.ScreenID === id),
                          ),
                        );
                      } else {
                        setSelectedTableRows(
                          pendingScreens.map((s) => s.ScreenID),
                        );
                      }
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#6366f1",
                      fontWeight: 600,
                      fontSize: 13,
                      padding: "0 4px",
                    }}
                  >
                    {allPendingSelected ? t.deselectAll : t.selectAll}
                  </button>
                </div>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    flexShrink: 0,
                  }}
                >
                  <button
                    onClick={() => {
                      const label = hasSelection
                        ? t.publishSelectedConfirm(targetCount)
                        : t.publishAllConfirm(targetCount);
                      Modal.confirm({
                        title: label,
                        icon: <ExclamationCircleOutlined />,
                        content: hasSelection
                          ? t.publishSelectedDesc(targetCount)
                          : t.publishAllDesc,
                        okText: hasSelection
                          ? t.publishOkSelected(targetCount)
                          : t.publishAll,
                        cancelText: t.cancel,
                        onOk: () => {
                          targetScreens.forEach((s) => onPublish(s));
                        },
                      });
                    }}
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 7,
                      padding: "8px 20px",
                      borderRadius: 10,
                      border: "none",
                      background: "linear-gradient(135deg, #4f46e5, #6366f1)",
                      cursor: "pointer",
                      fontSize: 13,
                      fontWeight: 700,
                      color: "#fff",
                      boxShadow: "0 2px 10px rgba(99,102,241,0.35)",
                    }}
                  >
                    <Send size={14} />
                    {hasSelection
                      ? t.publishSelectedCount(targetCount)
                      : t.publishAllCount(targetCount)}
                  </button>
                </div>
              </div>
            );
          })()}
      </div>
    );
  };

  const renderDetailView = () => {
    const record =
      data.find((d) => d.ScreenID === selectedScreen?.ScreenID) ||
      selectedScreen;
    const {
      ScreenCode,
      ScreenName,
      CampaignName,
      CampaignID,
      PendingPublished = 0,
      ScreenID,
    } = record;

    const hasLinkedCampaign = !!(CampaignID && CampaignID !== "");

    const updateDetailScreenCampaign = (newCampaignID) => {
      const { requestServerPost, usertoken } = parentProps;
      const params = new FormData();
      params.append("screenid", ScreenID);
      params.append("campaignid", newCampaignID);
      requestServerPost(
        "update_screen",
        params,
        {},
        () => {
          setCampaignPopoverVisible(null);
          onNeedsReload();
        },
        usertoken,
      );
    };

    const detailCampaignPopoverContent = (
      <div style={{ width: 280 }} onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            fontSize: 12,
            color: "#64748b",
            marginBottom: 8,
            fontWeight: 500,
          }}
        >
          Link a campaign
        </div>
        <CampaignSelector
          value={hasLinkedCampaign ? Number(CampaignID) : -1}
          onSelect={(val) => updateDetailScreenCampaign(val)}
          getPopupContainer={(trigger) =>
            trigger.closest(".ant-popover-inner-content") || document.body
          }
          parentProps={parentProps}
        />
      </div>
    );

    if (!screensStatus[ScreenCode]) screensStatus[ScreenCode] = {};
    const isOnline = screensStatus[ScreenCode].is_online ?? 0;
    const isPaired = screensStatus[ScreenCode].is_paired ?? 0;
    const os = screensStatus[ScreenCode].os ?? "";
    const osVersion = screensStatus[ScreenCode].os_version ?? "";
    const playerVersion = screensStatus[ScreenCode].player_version ?? null;
    const isLocked = screensStatus[ScreenCode].lock
      ? screensStatus[ScreenCode].lock !== 0
      : false;

    const hasLicense = "LicenseKey" in record;
    const licenseActive = !CHECK_LICENSE
      ? true
      : "LicenseStatus" in record
        ? record.LicenseStatus === "active"
        : false;

    const now = new Date();
    const colorMap = {
      "No License": THEME_PALLETE.red,
      "License Active": "#52c41a",
      "License not started": "#1890ff",
      "License expired": "#fa8c16",
      "License Inactive": "#d9d9d9",
    };
    const inActiveReason = !hasLicense
      ? "No License"
      : licenseActive
        ? "License Active"
        : now < new Date(record.LicenseStartDate)
          ? "License not started"
          : now > new Date(record.LicenseEndDate)
            ? "License expired"
            : "License Inactive";

    const screencode = `${record.AccountCode}-${record.BrandCode}-${record.BranchCode}-${record.ScreenCode}`;

    const screenevents = (updatedEventData ? updatedEventData : eventData)
      .filter((e) => e.ScreenID === ScreenID)
      .sort((a, b) => b.Priority - a.Priority);

    const eventsContent =
      screenevents.length > 0 ? (
        <ScreenEventPlaylistModule
          onDataUpdated={(newEventData) => setUpdatedEventData(newEventData)}
          onSave={onScreenEventUpdated}
          eventTypesData={eventTypesData}
          data={screenevents}
          screenData={record}
        />
      ) : (
        <Button
          icon={<PlusCircleOutlined />}
          disabled={!createPermission}
          onClick={() => launchCreateScreenEventPlaylistPopup(record)}
          shape="round"
          type="link"
          size="small"
        >
          Add Event
        </Button>
      );

    const statusBadge = licenseActive ? (
      isOnline === 1 ? (
        <span className="screen-status-badge online">
          <span className="status-dot" />
          {t.online}
        </span>
      ) : (
        <span className="screen-status-badge offline">
          <span className="status-dot" />
          {t.offline}
        </span>
      )
    ) : (
      <Tag
        style={{
          color: colorMap[inActiveReason],
          border: `1px solid ${colorMap[inActiveReason]}`,
          margin: 0,
        }}
      >
        <LockOutlined /> {inActiveReason}
      </Tag>
    );

    let headerPublishBtn = null;
    if (allowPublishPermission) {
      if (!licenseActive) {
        headerPublishBtn = (
          <Tooltip title={t.manageLicenseTooltip}>
            <Button
              onClick={() => selectPage(Constants.LICENSE_PAGE)}
              type="dashed"
              style={{
                borderRadius: 10,
                height: 40,
                fontWeight: 700,
                fontSize: 14,
                paddingInline: 16,
              }}
            >
              {t.manageLicense}
            </Button>
          </Tooltip>
        );
      } else if (!CampaignID || CampaignID === "") {
        headerPublishBtn = (
          <Tooltip title={t.publishTooltip}>
            <PrimaryActionButton disabled icon={<Send size={15} />}>
              {t.publishToScreen}
            </PrimaryActionButton>
          </Tooltip>
        );
      } else {
        const title = isOnline ? t.publishInstant : t.publishWhenOnline;
        headerPublishBtn = (
          <PrimaryActionButton
            icon={<Send size={15} />}
            onClick={() => {
              Modal.confirm({
                title,
                icon: <ExclamationCircleOutlined />,
                okText: t.ok,
                cancelText: t.cancel,
                centered: true,
                onOk: () => onPublish(record),
              });
            }}
          >
            {t.publishToScreen}
          </PrimaryActionButton>
        );
      }
    }

    const infoRows = [
      {
        icon: <Wifi size={16} color="#10b981" />,
        label: t.infoConnection,
        value: isOnline === 1 ? t.online : t.offline,
      },
      {
        icon: <LayoutTemplate size={16} color="#eab308" />,
        label: t.infoCampaign,
        value: CampaignName || t.noCampaign,
        isYellow: true,
      },
      {
        icon: <Monitor size={16} color="#8b5cf6" />,
        label: t.infoDevice,
        value:
          screensStatus[ScreenCode]?.device_model || record.DeviceModel || "—",
      },
      {
        icon: <Info size={16} color="#64748b" />,
        label: t.infoOS || "Operating System",
        value: os || osVersion ? `${os} ${osVersion}`.trim() : "—",
      },
      {
        icon: <Info size={16} color="#64748b" />,
        label: t.infoAppVersion,
        value: playerVersion ? `v${playerVersion}` : "—",
      },
      {
        icon: <KeyRound size={16} color="#64748b" />,
        label: t.infoScreenCode,
        value: screencode,
      },
      {
        icon: licenseActive ? (
          <ShieldCheck size={16} color="#10b981" />
        ) : (
          <ShieldOff size={16} color="#ef4444" />
        ),
        label: t.infoLicense,
        value: inActiveReason,
      },
    ];

    /* ── Device-control panel (shared by the header "Device Controller" button) ── */
    const remoteSection = (label) => (
      <div
        style={{
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.08em",
          textTransform: "uppercase",
          color: "#94a3b8",
          margin: "0 2px 8px",
        }}
      >
        {label}
      </div>
    );

    const remoteBtn = (opts) => (
      <Tooltip title={opts.tip || opts.label} placement="top">
        <button
          onClick={opts.onClick}
          disabled={opts.disabled}
          onMouseEnter={(e) => {
            if (opts.disabled) return;
            e.currentTarget.style.borderColor = opts.danger
              ? "#fca5a5"
              : "#c7d2fe";
            e.currentTarget.style.boxShadow = "0 6px 16px rgba(15,23,42,0.08)";
            e.currentTarget.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.borderColor = "#eef2f7";
            e.currentTarget.style.boxShadow = "0 1px 2px rgba(15,23,42,0.04)";
            e.currentTarget.style.transform = "translateY(0)";
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 8,
            padding: "14px 6px",
            borderRadius: 14,
            border: "1px solid #eef2f7",
            background: "#fff",
            boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
            cursor: opts.disabled ? "not-allowed" : "pointer",
            opacity: opts.disabled ? 0.4 : 1,
            transition: "all 0.18s ease",
          }}
        >
          <span
            style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: opts.iconBg,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            {opts.icon}
          </span>
          <span
            style={{
              fontSize: 11,
              fontWeight: 600,
              color: opts.danger ? "#ef4444" : "#475569",
              whiteSpace: "nowrap",
            }}
          >
            {opts.label}
          </span>
        </button>
      </Tooltip>
    );

    const remoteControlContent = (
      <div style={{ width: 272 }}>
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 16,
            paddingBottom: 14,
            borderBottom: "1px solid #f1f5f9",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
            }}
          >
            <span
              style={{
                width: 32,
                height: 32,
                borderRadius: 10,
                background: "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Cpu size={16} color="#6366f1" />
            </span>
            <span
              style={{
                color: "#0f172a",
                fontWeight: 600,
                fontSize: 14,
              }}
            >
              Device Control
            </span>
          </div>
          <span
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: 5,
              fontSize: 11,
              fontWeight: 600,
              padding: "3px 9px",
              borderRadius: 20,
              background: isOnline ? "#ecfdf5" : "#fef2f2",
              color: isOnline ? "#059669" : "#dc2626",
            }}
          >
            <span
              style={{
                width: 6,
                height: 6,
                borderRadius: "50%",
                background: isOnline ? "#10b981" : "#ef4444",
              }}
            />
            {isOnline ? t.online : t.offline}
          </span>
        </div>

        {/* Display */}
        {remoteSection("Display")}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: 8,
            marginBottom: 14,
          }}
        >
          {remoteBtn({
            label: "Saturation",
            iconBg: "linear-gradient(135deg,#eff6ff,#dbeafe)",
            icon: (
              <FormatPainterFilled style={{ color: "#3b82f6", fontSize: 16 }} />
            ),
            onClick: () => {
              setRemoteControlOpen(false);
              setSaturationModalScreen(record);
            },
          })}
          {editBrightness &&
            remoteBtn({
              label: "Brightness",
              iconBg: "linear-gradient(135deg,#fffbeb,#fef3c7)",
              icon: (
                <img
                  src="/cms/assets/svgs/icons/brightness_icon.svg"
                  style={{ width: 16, height: 16 }}
                  alt=""
                />
              ),
              onClick: () => {
                setRemoteControlOpen(false);
                onEditBrightness(record);
              },
            })}
        </div>

        {isPaired === 1 && (
          <>
            {/* Playback */}
            {remoteSection("Playback")}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr 1fr",
                gap: 8,
                marginBottom: 14,
              }}
            >
              {remoteBtn({
                label: "Play",
                disabled: !isOnline,
                iconBg: "linear-gradient(135deg,#f0fdf4,#dcfce7)",
                icon: (
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_play.svg"
                    style={{ width: 16, height: 16 }}
                    alt=""
                  />
                ),
                onClick: () => onPreRemoteAction(record, "toggle_play"),
              })}
              {remoteBtn({
                label: "Stop",
                disabled: !isOnline,
                iconBg: "linear-gradient(135deg,#f8fafc,#f1f5f9)",
                icon: (
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_stop.svg"
                    style={{ width: 16, height: 16 }}
                    alt=""
                  />
                ),
                onClick: () => onPreRemoteAction(record, "toggle_play"),
              })}
              {remoteBtn({
                label: "Reload",
                disabled: !isOnline,
                iconBg: "linear-gradient(135deg,#eff6ff,#dbeafe)",
                icon: (
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_player_reload.svg"
                    style={{ width: 16, height: 16 }}
                    alt=""
                  />
                ),
                onClick: () => onPreRemoteAction(record, "reload_player"),
              })}
            </div>

            {/* Power */}
            {remoteSection("Power")}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: 8,
              }}
            >
              {remoteBtn({
                label: "Reboot",
                disabled: !isOnline,
                iconBg: "linear-gradient(135deg,#fff7ed,#ffedd5)",
                icon: (
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_hardware_reboot.svg"
                    style={{ width: 16, height: 16 }}
                    alt=""
                  />
                ),
                onClick: () => onPreRemoteAction(record, "reboot_hardware"),
              })}
              {remoteBtn({
                label: "Shutdown",
                disabled: !isOnline,
                danger: true,
                iconBg: "linear-gradient(135deg,#fff1f2,#ffe4e6)",
                icon: (
                  <img
                    src="/cms/assets/svgs/icons/remote_tools/remote_hardware_shutdown.svg"
                    style={{ width: 16, height: 16 }}
                    alt=""
                  />
                ),
                onClick: () => onPreRemoteAction(record, "shutdown_hardware"),
              })}
            </div>
          </>
        )}
      </div>
    );

    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          minHeight: isMobile ? "auto" : "calc(100vh - 170px)",
        }}
      >
        {/* Detail header — screen identity + primary actions */}
        <div
          style={{
            background: "#fff",
            border: "1px solid #e8ecf3",
            borderRadius: 16,
            padding: isMobile ? "14px 16px" : "16px 20px",
            marginBottom: 20,
            boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            alignItems: isMobile ? "flex-start" : "center",
            justifyContent: "space-between",
            gap: 12,
            flexWrap: "wrap",
            flexShrink: 0,
          }}
        >
          {/* Left: back + identity */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 14,
              minWidth: 0,
            }}
          >
            <Tooltip title={t.allScreens} placement="bottom">
              <button
                onClick={() => setSelectedScreen(null)}
                onMouseEnter={(e) =>
                  (e.currentTarget.style.background = "#f1f5f9")
                }
                onMouseLeave={(e) =>
                  (e.currentTarget.style.background = "#fff")
                }
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 40,
                  height: 40,
                  borderRadius: 12,
                  border: "1px solid #e2e8f0",
                  background: "#fff",
                  cursor: "pointer",
                  color: "#64748b",
                  flexShrink: 0,
                  transition: "background 0.15s",
                }}
              >
                <ArrowLeft size={18} />
              </button>
            </Tooltip>
            <div
              style={{
                width: 48,
                height: 48,
                borderRadius: 14,
                background: isLocked
                  ? "linear-gradient(135deg,#fef2f2,#fee2e2)"
                  : "linear-gradient(135deg,#6366f1,#4f46e5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
                boxShadow: isLocked
                  ? "none"
                  : "0 8px 18px rgba(99,102,241,0.18)",
              }}
            >
              <MonitorPlay size={24} color={isLocked ? "#ef4444" : "#ffffff"} />
            </div>
            <div style={{ minWidth: 0 }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  flexWrap: "wrap",
                }}
              >
                <h1
                  style={{
                    margin: 0,
                    fontWeight: 800,
                    fontSize: 20,
                    color: "#0f172a",
                    lineHeight: 1.2,
                  }}
                >
                  {ScreenName}
                </h1>
                {statusBadge}
                {PendingPublished === 1 && (
                  <Tag
                    icon={<ExclamationCircleOutlined />}
                    color="orange"
                    style={{ fontSize: 11, margin: 0 }}
                  >
                    Pending
                  </Tag>
                )}
              </div>
              <div style={{ fontSize: 13, color: "#94a3b8", marginTop: 3 }}>
                {isPaired === 1 ? t.paired : t.notPaired}
                {record.BranchCode ? ` • ${record.BranchCode}` : ""}
              </div>
            </div>
          </div>

          {/* Right: primary actions */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 10,
              flexWrap: "wrap",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <Popover
              open={remoteControlOpen}
              onOpenChange={(v) => setRemoteControlOpen(v)}
              trigger="click"
              placement="bottomRight"
              overlayInnerStyle={{
                background: "#ffffff",
                borderRadius: 16,
                padding: 18,
                boxShadow: "0 20px 50px rgba(15,23,42,0.16)",
                border: "1px solid #f1f5f9",
              }}
              content={remoteControlContent}
            >
              <Button
                icon={<MdOutlineSettingsRemote size={16} />}
                style={{
                  borderRadius: 10,
                  height: 40,
                  fontWeight: 700,
                  fontSize: 14,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  paddingInline: 16,
                  // color: "#4f46e5",
                  // borderColor: "#c7d2fe",
                  // background: "#eef2ff",
                  color: "#334155",
                  borderColor: "#e2e8f0",
                }}
              >
                {t.deviceController || "Device Controller"}
              </Button>
            </Popover>

            {editPermission && (
              <Button
                onClick={() => onEdit(record)}
                icon={
                  <img
                    src="/cms/assets/svgs/icons/edit_icon.svg"
                    style={{ width: 15, height: 15 }}
                    alt=""
                  />
                }
                style={{
                  borderRadius: 10,
                  height: 40,
                  fontWeight: 700,
                  fontSize: 14,
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  paddingInline: 16,
                  color: "#334155",
                  borderColor: "#e2e8f0",
                }}
              >
                {t.editScreen || "Edit Screen"}
              </Button>
            )}

            {headerPublishBtn}
          </div>
        </div>

        <Row
          gutter={[16, 16]}
          style={{
            alignItems: isMobile ? "flex-start" : "stretch",
            flex: isMobile ? "none" : 1,
          }}
        >
          {/* Left: Screen info */}
          <Col
            xs={24}
            lg={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                border: "1px solid #f1f5f9",
                borderRadius: 16,
                backgroundColor: "#fff",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                flex: isMobile ? "none" : 1,
              }}
            >
              {/* Card header */}
              <div
                style={{
                  padding: "16px 24px",
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  borderBottom: "1px solid #f1f5f9",
                }}
              >
                <div
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: 8,
                    background: "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Info size={14} color="#6366f1" />
                </div>
                <span
                  style={{ fontWeight: 600, fontSize: 14, color: "#1e293b" }}
                >
                  {t.screenInfo || "Screen Details"}
                </span>
              </div>

              {/* Info rows — scrollable on desktop, page-scroll on mobile */}
              <div
                style={{
                  flex: isMobile ? "none" : 1,
                  overflowY: isMobile ? "visible" : "auto",
                }}
              >
                {infoRows.map((row, idx) => (
                  <div
                    key={idx}
                    style={{
                      padding: "14px 24px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      borderBottom: "1px solid #f8fafc",
                    }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      {row.icon}
                      <span style={{ color: "#64748b", fontSize: 13 }}>
                        {row.label}
                      </span>
                    </div>
                    {row.isYellow ? (
                      hasLinkedCampaign ? (
                        /* Linked: split-pill — left clicks navigate, right × unlinks */
                        <div
                          style={{
                            display: "inline-flex",
                            alignItems: "stretch",
                            borderRadius: 8,
                            border: "1px solid #fde047",
                            background: "#fef9c3",
                            overflow: "hidden",
                            fontSize: 12,
                            lineHeight: 1,
                          }}
                        >
                          <Tooltip
                            title={`Go to campaign: ${CampaignName}`}
                            placement="top"
                            mouseEnterDelay={0.6}
                          >
                            <button
                              onClick={() => onCampaignClicked(record)}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                padding: "4px 8px 4px 10px",
                                background: "transparent",
                                border: "none",
                                cursor: "pointer",
                                fontWeight: 600,
                                color: "#854d0e",
                                fontSize: 12,
                              }}
                            >
                              {row.value}
                            </button>
                          </Tooltip>
                          <Popover
                            content={detailCampaignPopoverContent}
                            trigger="click"
                            placement="bottomRight"
                            open={
                              campaignPopoverVisible ===
                              `detail-change-${ScreenCode}`
                            }
                            onOpenChange={(v) =>
                              setCampaignPopoverVisible(
                                v ? `detail-change-${ScreenCode}` : null,
                              )
                            }
                            overlayInnerStyle={{
                              borderRadius: 12,
                              padding: "12px 14px",
                            }}
                          >
                            <button
                              onClick={(e) => e.stopPropagation()}
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                width: 24,
                                background: "transparent",
                                border: "none",
                                borderLeft: "1px solid #fde047",
                                cursor: "pointer",
                                color: "#854d0e",
                                transition: "background 0.15s",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background =
                                  "rgba(133, 77, 14, 0.08)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background =
                                  "transparent";
                              }}
                            >
                              <CaretDownOutlined style={{ fontSize: 10 }} />
                            </button>
                          </Popover>
                        </div>
                      ) : (
                        <Popover
                          content={detailCampaignPopoverContent}
                          trigger="click"
                          placement="bottomRight"
                          open={
                            campaignPopoverVisible === `detail-${ScreenCode}`
                          }
                          onOpenChange={(v) =>
                            setCampaignPopoverVisible(
                              v ? `detail-${ScreenCode}` : null,
                            )
                          }
                          overlayInnerStyle={{
                            borderRadius: 12,
                            padding: "12px 14px",
                          }}
                        >
                          <button
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 5,
                              padding: "4px 10px",
                              borderRadius: 20,
                              background:
                                "linear-gradient(135deg, #fffbeb, #fef3c7)",
                              border: "1.5px solid #fcd34d",
                              fontSize: 12,
                              color: "#b45309",
                              fontWeight: 600,
                              cursor: "pointer",
                            }}
                          >
                            {t.addCampaign || "+ Campaign"}
                          </button>
                        </Popover>
                      )
                    ) : (
                      <span
                        style={{
                          fontWeight: 500,
                          fontSize: 13,
                          color: "#0f172a",
                          maxWidth: 300,
                          textAlign: "right",
                          wordBreak: "break-all",
                        }}
                      >
                        {row.value}
                      </span>
                    )}
                  </div>
                ))}
              </div>
              {/* Timezone Selector Row */}
              <div
                style={{
                  padding: "14px 24px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  borderTop: "1px solid #f8fafc",
                }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <Globe size={16} color="#3b82f6" />
                  <span style={{ color: "#64748b", fontSize: 13 }}>
                    {t.timezone || "Timezone"}
                  </span>
                </div>
                <Select
                  value={screensStatus[ScreenCode]?.timezone || "UTC"}
                  onChange={(val) => handleTimezoneChange(val, record)}
                  style={{ width: 220 }}
                  size="small"
                  showSearch
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {TIMEZONE_OPTIONS.map((tz) => (
                    <Select.Option key={tz.value} value={tz.value}>
                      {tz.label}
                    </Select.Option>
                  ))}
                </Select>
              </div>

              {/* Footer actions */}
              <div
                style={{
                  padding: "14px 24px",
                  display: "flex",
                  gap: 10,
                  borderTop: "1px solid #f1f5f9",
                  flexWrap: "wrap",
                }}
              >
                <Button
                  onClick={() => onNeedsReload()}
                  icon={<RefreshCw size={15} />}
                  style={{
                    flex: 1,
                    borderRadius: 10,
                    height: 40,
                    fontWeight: 700,
                    fontSize: 14,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 6,
                    paddingInline: 16,
                    color: "#334155",
                    borderColor: "#e2e8f0",
                  }}
                >
                  {t.reloadPage || "Reload Page"}
                </Button>

                {isPaired === 1 ? (
                  <Button
                    danger
                    onClick={() => onNeedsUnpair(record)}
                    icon={<DisconnectOutlined />}
                    style={{
                      flex: 1,
                      borderRadius: 10,
                      height: 40,
                      fontWeight: 700,
                      fontSize: 14,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      paddingInline: 16,
                      color: "#ef4444",
                      borderColor: "#fca5a5",
                      background: "#fff",
                    }}
                  >
                    {t.unpairDevice || "Unpair Device"}
                  </Button>
                ) : (
                  createPermission && (
                    <Button
                      onClick={() => onPairScreen(record)}
                      icon={<LinkOutlined />}
                      style={{
                        flex: 1,
                        borderRadius: 10,
                        height: 40,
                        fontWeight: 700,
                        fontSize: 14,
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: 6,
                        paddingInline: 16,
                        color: "#2563eb",
                        borderColor: "#bfdbfe",
                        background: "#fff",
                      }}
                    >
                      {t.pairDevice || "Pair Device"}
                    </Button>
                  )
                )}

                {deletePermission && (
                  <Button
                    danger
                    icon={<DeleteOutlined />}
                    style={{
                      flex: 1,
                      borderRadius: 10,
                      height: 40,
                      fontWeight: 700,
                      fontSize: 14,
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: 6,
                      paddingInline: 16,
                      color: "#ef4444",
                      borderColor: "#fca5a5",
                      background: "#fff",
                    }}
                    onClick={() => {
                      Modal.confirm({
                        title: t.deleteConfirm,
                        icon: <ExclamationCircleOutlined />,
                        okText: t.delete,
                        okType: "danger",
                        cancelText: t.cancel,
                        centered: true,
                        onOk: () => {
                          onDelete(record);
                          setSelectedScreen(null);
                        },
                      });
                    }}
                  >
                    {t.deleteScreen || "Delete Screen"}
                  </Button>
                )}
              </div>
            </div>
          </Col>

          {/* Right: Publish + Events */}
          <Col
            xs={24}
            lg={12}
            style={{ display: "flex", flexDirection: "column" }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: 14,
                flex: 1,
              }}
            >
              {/* Screen Preview card */}
              {(() => {
                // Resolve the currently selected preview dimensions
                const getSelectedDims = () => {
                  if (previewResolutionMode === "custom") {
                    const w = Number(previewCustomWidth) || 1920;
                    const h = Number(previewCustomHeight) || 1080;
                    return {
                      width: w,
                      height: h,
                      aspect: h > 0 ? w / h : 16 / 9,
                      label: `${w} × ${h}`,
                    };
                  }
                  const [rw, rh] = previewSelectedRatio.value
                    .split("/")
                    .map(Number);
                  return {
                    width: rw,
                    height: rh,
                    aspect: rh > 0 ? rw / rh : 16 / 9,
                    label: previewSelectedRatio.label,
                  };
                };
                const dims = getSelectedDims();
                const ratio = dims.aspect;
                // Fit the frame within a max box while preserving aspect ratio
                const MAX_W = 260;
                const MAX_H = 150;
                let frameW = MAX_W;
                let frameH = frameW / ratio;
                if (frameH > MAX_H) {
                  frameH = MAX_H;
                  frameW = frameH * ratio;
                }
                return (
                  <div
                    style={{
                      border: "1px solid #f1f5f9",
                      borderRadius: 16,
                      backgroundColor: "#fff",
                      padding: "16px 20px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        marginBottom: 16,
                      }}
                    >
                      <div
                        style={{
                          width: 32,
                          height: 32,
                          borderRadius: 8,
                          background: "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <LayoutTemplate size={14} color="#6366f1" />
                      </div>
                      <span
                        style={{
                          fontWeight: 600,
                          fontSize: 14,
                          color: "#1e293b",
                        }}
                      >
                        {t.screenPreview || "Screen Preview"}
                      </span>
                    </div>

                    {/* Resolution mode tabs */}
                    <div
                      style={{
                        display: "flex",
                        gap: 4,
                        marginBottom: 14,
                        background: "#f1f5f9",
                        borderRadius: 10,
                        padding: 4,
                      }}
                    >
                      {[
                        {
                          key: "preset",
                          label: t.presetRatio || "Aspect Ratio",
                        },
                        {
                          key: "custom",
                          label: t.customResolution || "Custom Resolution",
                        },
                      ].map((m) => (
                        <button
                          key={m.key}
                          onClick={() => setPreviewResolutionMode(m.key)}
                          style={{
                            flex: 1,
                            padding: "6px 0",
                            borderRadius: 8,
                            border: "none",
                            cursor: "pointer",
                            fontWeight: 600,
                            fontSize: 12,
                            transition: "all 0.2s",
                            background:
                              previewResolutionMode === m.key
                                ? "#ffffff"
                                : "transparent",
                            color:
                              previewResolutionMode === m.key
                                ? "#6366f1"
                                : "#94a3b8",
                            boxShadow:
                              previewResolutionMode === m.key
                                ? "0 1px 4px rgba(0,0,0,0.08)"
                                : "none",
                          }}
                        >
                          {m.label}
                        </button>
                      ))}
                    </div>

                    {previewResolutionMode === "preset" ? (
                      /* Ratio buttons */
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "nowrap",
                          gap: 6,
                          marginBottom: 16,
                        }}
                      >
                        {SCREEN_RATIOS.map((r) => {
                          const active = previewSelectedRatio.value === r.value;
                          return (
                            <button
                              key={r.value}
                              onClick={() => setPreviewSelectedRatio(r)}
                              style={{
                                flex: 1,
                                padding: "8px 0",
                                borderRadius: 8,
                                cursor: "pointer",
                                fontWeight: 600,
                                fontSize: 12,
                                transition: "all 0.15s",
                                border: active
                                  ? "1.5px solid #6366f1"
                                  : "1px solid #e2e8f0",
                                background: active ? "#eef2ff" : "#fff",
                                color: active ? "#4f46e5" : "#64748b",
                              }}
                            >
                              {r.label}
                            </button>
                          );
                        })}
                      </div>
                    ) : (
                      /* Custom resolution inputs */
                      <div
                        style={{
                          display: "flex",
                          gap: 10,
                          alignItems: "flex-end",
                          marginBottom: 16,
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <span
                            style={{
                              fontSize: 11,
                              color: "#94a3b8",
                              display: "block",
                              marginBottom: 4,
                            }}
                          >
                            {t.width || "Width"} (px)
                          </span>
                          <InputNumber
                            min={1}
                            value={previewCustomWidth}
                            onChange={(v) => setPreviewCustomWidth(v || 1920)}
                            style={{ width: "100%", borderRadius: 8 }}
                          />
                        </div>
                        <span
                          style={{
                            paddingBottom: 6,
                            color: "#94a3b8",
                            fontWeight: 600,
                          }}
                        >
                          ×
                        </span>
                        <div style={{ flex: 1 }}>
                          <span
                            style={{
                              fontSize: 11,
                              color: "#94a3b8",
                              display: "block",
                              marginBottom: 4,
                            }}
                          >
                            {t.height || "Height"} (px)
                          </span>
                          <InputNumber
                            min={1}
                            value={previewCustomHeight}
                            onChange={(v) => setPreviewCustomHeight(v || 1080)}
                            style={{ width: "100%", borderRadius: 8 }}
                          />
                        </div>
                      </div>
                    )}

                    {/* Aspect-ratio frame */}
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        marginBottom: 8,
                      }}
                    >
                      <div
                        style={{
                          position: "relative",
                          width: frameW,
                          height: frameH,
                          borderRadius: 12,
                          background: "linear-gradient(135deg,#0f172a,#1e293b)",
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "center",
                          justifyContent: "center",
                          overflow: "hidden",
                          boxShadow: "0 8px 24px rgba(15,23,42,0.18)",
                          transition: "width 0.25s ease, height 0.25s ease",
                        }}
                      >
                        <MonitorPlay size={28} color="rgba(255,255,255,0.2)" />
                        <span
                          style={{
                            color: "rgba(255,255,255,0.4)",
                            fontSize: 11,
                            marginTop: 8,
                            maxWidth: frameW - 16,
                            padding: "0 8px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            textAlign: "center",
                          }}
                        >
                          {CampaignName || t.noCampaign}
                        </span>
                        <span
                          style={{
                            position: "absolute",
                            bottom: 8,
                            right: 10,
                            fontSize: 10,
                            fontWeight: 600,
                            color: "rgba(255,255,255,0.55)",
                            background: "rgba(0,0,0,0.35)",
                            padding: "2px 6px",
                            borderRadius: 6,
                          }}
                        >
                          {dims.label}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        textAlign: "center",
                        marginBottom: 16,
                        fontSize: 12,
                        color: "#94a3b8",
                      }}
                    >
                      {previewResolutionMode === "custom"
                        ? `${previewCustomWidth} × ${previewCustomHeight} px`
                        : `${previewSelectedRatio.description} (${previewSelectedRatio.label})`}
                    </div>

                    <Tooltip title={hasLinkedCampaign ? "" : t.publishTooltip}>
                      <Button
                        block
                        icon={<Eye size={14} />}
                        disabled={!hasLinkedCampaign}
                        onClick={() => onPreviewContent(record, dims)}
                        style={{
                          borderRadius: 8,
                          height: 40,
                          fontWeight: 600,
                        }}
                      >
                        {t.preview || "Preview"}
                      </Button>
                    </Tooltip>
                  </div>
                );
              })()}

              {/* Publish card */}
              <div
                style={{
                  border: "1px solid #f1f5f9",
                  borderRadius: 16,
                  backgroundColor: "#fff",
                  padding: "20px 24px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    marginBottom: 16,
                  }}
                >
                  <div
                    style={{
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      background: "linear-gradient(135deg,#eef2ff,#e0e7ff)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Send size={14} color="#6366f1" />
                  </div>
                  <span
                    style={{ fontWeight: 600, fontSize: 14, color: "#1e293b" }}
                  >
                    {t.publishContent}
                  </span>
                </div>

                {/* Publishing tools: schedule & history */}
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr",
                    gap: 8,
                  }}
                >
                  <Button
                    icon={<ClockCircleOutlined />}
                    onClick={() =>
                      PopupManager.launchPublishingScheduleManagerPopup(record)
                    }
                    style={{
                      borderRadius: 8,
                      height: 38,
                      fontWeight: 600,
                      fontSize: 13,
                    }}
                  >
                    {t.menuScheduleTitle || "Schedule"}
                  </Button>
                  <Button
                    icon={<HistoryOutlined />}
                    onClick={() => {
                      setPublishingHistoryScreenData(record);
                      setPublishingHistoryVisible(true);
                    }}
                    style={{
                      borderRadius: 8,
                      height: 38,
                      fontWeight: 600,
                      fontSize: 13,
                    }}
                  >
                    {t.menuHistoryTitle || "History"}
                  </Button>
                </div>
              </div>

              {/* Events card */}
              <div
                style={{
                  border: "1px solid #f1f5f9",
                  borderRadius: 16,
                  backgroundColor: "#fff",
                  overflow: "hidden",
                  flex: 1,
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <div
                  style={{
                    padding: "16px 20px",
                    borderBottom: "1px solid #f8fafc",
                    fontWeight: 600,
                    fontSize: 14,
                    color: "#1e293b",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span>{t.events(screenevents.length)}</span>
                  {createPermission && (
                    <Button
                      size="small"
                      type="link"
                      icon={<PlusCircleOutlined />}
                      onClick={() =>
                        launchCreateScreenEventPlaylistPopup(record)
                      }
                    >
                      {t.add}
                    </Button>
                  )}
                </div>
                <div
                  style={{ padding: "12px 16px", flex: 1, overflowY: "auto" }}
                >
                  {eventsContent}
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  };

  /* â”€â”€ Saturation Modal (works in all views) â”€â”€ */
  const saturationScreen = saturationModalScreen;
  const satScreenCode = saturationScreen?.ScreenCode;

  return (
    <>
      <Modal
        open={!!saturationScreen}
        onCancel={() => setSaturationModalScreen(null)}
        footer={null}
        title={`Adjust Saturation — ${saturationScreen?.ScreenName || ""}`}
        width={340}
        centered
      >
        {saturationScreen && (
          <div style={{ padding: "8px 0" }}>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 12,
                marginBottom: 16,
              }}
            >
              <Slider
                min={0}
                max={1}
                step={0.01}
                style={{ flex: 1 }}
                value={
                  tempFormatValues[satScreenCode] ??
                  formatValues[satScreenCode] ??
                  1
                }
                onChange={(val) =>
                  setTempFormatValues((prev) => ({
                    ...prev,
                    [satScreenCode]: val,
                  }))
                }
                tooltip={{ formatter: (v) => `${Math.round(v * 100)}%` }}
              />
              <InputNumber
                min={0}
                max={1}
                step={0.01}
                style={{ width: 80 }}
                value={
                  tempFormatValues[satScreenCode] ??
                  formatValues[satScreenCode] ??
                  1
                }
                onChange={(val) =>
                  setTempFormatValues((prev) => ({
                    ...prev,
                    [satScreenCode]: val ?? 1,
                  }))
                }
              />
            </div>
            <div
              style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}
            >
              <Button onClick={() => setSaturationModalScreen(null)}>
                Cancel
              </Button>
              <Button
                type="primary"
                onClick={() => {
                  const newVal =
                    tempFormatValues[satScreenCode] ??
                    formatValues[satScreenCode] ??
                    1;
                  setFormatValues((prev) => ({
                    ...prev,
                    [satScreenCode]: newVal,
                  }));
                  try {
                    if (firebase && firebase.database) {
                      const { AccountCode, BrandCode, BranchCode } =
                        saturationScreen;
                      firebase
                        .database()
                        .ref(`${AccountCode}/${BrandCode}/${BranchCode}`)
                        .child(satScreenCode)
                        .update({ saturation: newVal });
                    }
                  } catch (e) {
                    console.warn("Firebase update failed:", e);
                  }
                  message.success("Saturation updated successfully");
                  setSaturationModalScreen(null);
                }}
              >
                Save
              </Button>
            </div>
          </div>
        )}
      </Modal>

      {selectedScreen ? (
        renderDetailView()
      ) : isMobile ? (
        <div style={{ marginTop: 16 }}>
          <motion.div
            variants={Animations.LIST_CONTAINER}
            initial="hidden"
            animate="show"
          >
            {renderMobileCards()}
          </motion.div>
        </div>
      ) : (
        renderTableDesktop()
      )}
      {false && (
        <AbstractTableView
          rowClassName={(record) => {
            return !CHECK_LICENSE
              ? "active"
              : "LicenseStatus" in record && record.LicenseStatus == "active"
                ? ""
                : "disabled-row";
          }}
          onRowClicked={onRowClicked}
          data={mappedData}
        >
          {(d) => {
            return (
              <>
                <Column
                  defaultSortOrder="ascend"
                  width="200px"
                  style={{ whiteSpace: "no-wrap" }}
                  sorter={(a, b) => {
                    return a.ScreenName > b.ScreenName ? 1 : -1;
                  }}
                  title="Name"
                  dataIndex="ScreenName"
                  key="ScreenName"
                  render={(name, record, index) => {
                    const { PendingPublished = 0 } = record;
                    const screencode = `${record.AccountCode}-${record.BrandCode}-${record.BranchCode}-${record.ScreenCode}`;
                    let nameElement = null;

                    if (screensStatus[record.ScreenCode]) {
                      const isLocked =
                        "lock" in screensStatus[record.ScreenCode]
                          ? screensStatus[record.ScreenCode].lock === 0
                            ? false
                            : true
                          : false;
                      nameElement = (
                        <ScreenIconView
                          isLocked={isLocked}
                          screensStatus={screensStatus}
                          onRemoteAction={onRemoteAction}
                          name={name}
                          screencode={screencode}
                          onScreenClicked={onScreenClicked}
                          record={record}
                        ></ScreenIconView>
                      );
                    } else {
                      nameElement = (
                        <ScreenIconView
                          isLocked={false}
                          screensStatus={screensStatus}
                          onRemoteAction={onRemoteAction}
                          name={name}
                          screencode={screencode}
                          onScreenClicked={onScreenClicked}
                          record={record}
                        ></ScreenIconView>
                      );
                    }

                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        {nameElement}
                        {PendingPublished == 1 && (
                          <Tag
                            icon={<ExclamationCircleOutlined />}
                            color="orange"
                            style={{
                              fontSize: 11,
                              padding: "0px 6px",
                              borderRadius: 6,
                            }}
                          >
                            {t.pendingPublish}
                          </Tag>
                        )}
                      </div>
                    );
                    // return <><Tooltip title={screencode}><CopyToClipboard text={screencode} onCopy={() => { message.success('Screen code copied to clipboard'); }}><img style={{ cursor: "pointer", width: "16px", height: "20px", marginRight: "0px" }} src="/cms/assets/svgs/icons/screen_icon.svg"></img></CopyToClipboard></Tooltip><Tooltip title={name}><Button onClick={() => onScreenClicked(record)} type="link" shape="round" >{name}</Button></Tooltip></>
                  }}
                />
                <Column
                  align="center"
                  width="200px"
                  title="Campaign"
                  dataIndex="CampaignName"
                  sorter={(a, b) => {
                    return a.CampaignName > b.CampaignName ? 1 : -1;
                  }}
                  key="CampaignName"
                  render={(campaignname, record, index) => {
                    //  const path = `/${selectedBrandData.BrandID}/${selectedBranchData.BranchID}/campaign/${this.state.screensData[index].CampaignID}`
                    //  console.log("path path " + path)
                    //  history.push(path)

                    let campaignBTN = null;

                    if (campaignname === "") {
                      if (!editPermission)
                        campaignBTN = (
                          <Button
                            onClick={() => onCampaignClicked(record)}
                            disabled={true}
                            type="link"
                            shape="round"
                          >
                            No Campaign
                          </Button>
                        );
                      else
                        campaignBTN = (
                          <Button
                            onClick={() => onCampaignClicked(record)}
                            type="link"
                            shape="round"
                          >
                            + Select Campaign
                          </Button>
                        );
                    } else
                      campaignBTN = (
                        <button
                          key={`${campaignname}${index}`}
                          onClick={() =>
                            viewCampaignPermission && onCampaignClicked(record)
                          }
                          style={{
                            background: "#fff",
                            border: "1px dashed #cbd5e1",
                            borderRadius: 20,
                            padding: "3px 10px",
                            fontSize: 13,
                            fontWeight: 500,
                            color: viewCampaignPermission
                              ? "#334155"
                              : "#94a3b8",
                            cursor: viewCampaignPermission
                              ? "pointer"
                              : "not-allowed",
                            width: 200,
                            textAlign: "center",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            transition: "border-color 0.15s, background 0.15s",
                          }}
                          onMouseEnter={(e) => {
                            if (viewCampaignPermission) {
                              e.currentTarget.style.borderColor = "#94a3b8";
                              e.currentTarget.style.borderStyle = "solid";
                              e.currentTarget.style.background = "#f8fafc";
                              e.currentTarget.style.color = "#2563eb";
                            }
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.borderColor = "#cbd5e1";
                            e.currentTarget.style.borderStyle = "dashed";
                            e.currentTarget.style.background = "#fff";
                            e.currentTarget.style.color = "#334155";
                          }}
                        >
                          {campaignname}
                        </button>
                      );

                    return (
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {USE_CAMPAIGN_SYNC && record.CampaignSync && (
                          <Tooltip title="CampaignSync is Enabled">
                            <PartitionOutlined
                              style={{ color: "#ff4d4f", fontWeight: 600 }}
                            />{" "}
                          </Tooltip>
                        )}
                        {campaignBTN}
                      </div>
                    );
                  }}
                />
                <Column
                  align="left"
                  width="350px"
                  title={<span style={{ marginLeft: "35px" }}>Events</span>}
                  dataIndex="Events"
                  sorter={false}
                  key="Events"
                  render={(events, record, index) => {
                    const { ScreenID, EventTypeID } = record;
                    let toRender = null;
                    const screenevents = (
                      updatedEventData ? updatedEventData : eventData
                    )
                      .filter((e) => {
                        return e.ScreenID === ScreenID;
                      })
                      .sort((a, b) => {
                        return b.Priority - a.Priority;
                      });
                    if (screenevents.length > 0) {
                      toRender = (
                        <ScreenEventPlaylistModule
                          onDataUpdated={(newEventData) => {
                            setUpdatedEventData(newEventData);
                          }}
                          onSave={onScreenEventUpdated}
                          eventTypesData={eventTypesData}
                          data={screenevents}
                          screenData={record}
                        ></ScreenEventPlaylistModule>
                      );
                    } else {
                      toRender = (
                        <Button
                          icon={<PlusCircleOutlined />}
                          disabled={!createPermission}
                          onClick={() => {
                            launchCreateScreenEventPlaylistPopup(record);
                          }}
                          shape="round"
                          type="link"
                        >
                          {t.addEvent}
                        </Button>
                      );
                    }

                    return (
                      <Collapse defaultActiveKey={[]} ghost>
                        <Panel
                          style={{ textAlign: "left" }}
                          header={t.events(screenevents.length)}
                          key="1"
                        >
                          <span style={{ color: "blue !important" }}>
                            {toRender}
                          </span>
                        </Panel>
                      </Collapse>
                    );
                  }}
                />

                <Column
                  align="center"
                  width="50px"
                  title="Status"
                  dataIndex="ScreenCode"
                  sorter={(a, b) => {
                    if (!screensStatus[a.ScreenCode]) {
                      return 1;
                    }
                    if (!screensStatus[b.ScreenCode]) {
                      return -1;
                    }
                    const isAOnline =
                      "is_online" in screensStatus[a.ScreenCode]
                        ? screensStatus[a.ScreenCode].is_online
                        : 0;
                    const isBOnline =
                      "is_online" in screensStatus[b.ScreenCode]
                        ? screensStatus[b.ScreenCode].is_online
                        : 0;

                    return isAOnline > isBOnline ? 1 : -1;
                  }}
                  key="ScreenCode"
                  render={(ScreenCode, record, index) => {
                    if (!screensStatus[ScreenCode]) {
                      screensStatus[ScreenCode] = {};
                    }
                    const isOnline =
                      "is_online" in screensStatus[ScreenCode]
                        ? screensStatus[ScreenCode].is_online
                        : 0;
                    const hasLicense = "LicenseKey" in record;
                    const licenseActive = !CHECK_LICENSE
                      ? true
                      : "LicenseStatus" in record
                        ? record.LicenseStatus == "active"
                        : false;
                    // console.log("screensStatus[ScreenCode] " + JSON.stringify(screensStatus))
                    const now = new Date();
                    const startDate = new Date(record.LicenseStartDate);
                    const endDate = new Date(record.LicenseEndDate);

                    // Active if current date is within start and end
                    const inActiveReason = !hasLicense
                      ? "No License"
                      : licenseActive
                        ? "License Active"
                        : now < startDate
                          ? `License not started`
                          : now > endDate
                            ? `License expired`
                            : "License Inactive";
                    // const inActiveReason = `License expired` ;

                    const colorMap = {
                      "No License": THEME_PALLETE.red,
                      "License Active": "#52c41a",
                      "License not started": "#1890ff",
                      "License expired": "#fa8c16",
                      "License Inactive": "#d9d9d9",
                    };

                    return licenseActive ? (
                      isOnline === 1 ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              verticalAlign: "middle",
                              backgroundColor: "#20F772",
                              width: "12px",
                              height: "12px",
                              display: "inline-block",
                              borderRadius: "6px",
                              marginRight: "10px",
                            }}
                          ></div>
                          Online
                        </div>
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <div
                            style={{
                              verticalAlign: "middle",
                              backgroundColor: "red",
                              width: "12px",
                              height: "12px",
                              display: "inline-block",
                              borderRadius: "6px",
                              marginRight: "10px",
                            }}
                          ></div>
                          Offline
                        </div>
                      )
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          opacity: 1,
                          alignItems: "center",
                          justifyContent: "center",
                          fontWeight: 500,
                          color: colorMap[inActiveReason],
                        }}
                      >
                        <div style={{ marginRight: "10px" }}>
                          <LockOutlined />
                        </div>
                        {inActiveReason}
                      </div>
                    );
                  }}
                />
                <Column
                  align="center"
                  width="200px"
                  title="Pairing Status"
                  dataIndex="ScreenCode"
                  sorter={(a, b) => {
                    if (!screensStatus[a.ScreenCode]) {
                      return 1;
                    }
                    if (!screensStatus[b.ScreenCode]) {
                      return -1;
                    }

                    const isAPaired =
                      "is_paired" in screensStatus[a.ScreenCode]
                        ? screensStatus[a.ScreenCode].is_paired
                        : 0;
                    const aOS =
                      "os" in screensStatus[a.ScreenCode]
                        ? screensStatus[a.ScreenCode].os
                        : "";
                    const aOSVersion =
                      "os_version" in screensStatus[a.ScreenCode]
                        ? screensStatus[a.ScreenCode].os_version
                        : "";

                    const isBPaired =
                      "is_paired" in screensStatus[b.ScreenCode]
                        ? screensStatus[b.ScreenCode].is_paired
                        : 0;
                    const bOS =
                      "os" in screensStatus[b.ScreenCode]
                        ? screensStatus[b.ScreenCode].os
                        : "";
                    const bOSVersion =
                      "os_version" in screensStatus[b.ScreenCode]
                        ? screensStatus[b.ScreenCode].os_version
                        : "";

                    if (isAPaired === 0) {
                      return -1;
                    } else if (isBPaired === 0) {
                      return 1;
                    } else {
                      return (
                        `${aOS} (${aOSVersion})` > `${bOS} (${bOSVersion})`
                      );
                    }
                  }}
                  key="PairingStatus"
                  render={(ScreenCode, record) => {
                    if (!screensStatus[ScreenCode]) {
                      screensStatus[ScreenCode] = {};
                    }
                    const isPaired =
                      "is_paired" in screensStatus[ScreenCode]
                        ? screensStatus[ScreenCode].is_paired
                        : 0;
                    const os =
                      "os" in screensStatus[ScreenCode]
                        ? screensStatus[ScreenCode].os
                        : "";
                    const osVersion =
                      "os_version" in screensStatus[ScreenCode]
                        ? screensStatus[ScreenCode].os_version
                        : "";
                    const playerVersion =
                      "player_version" in screensStatus[ScreenCode]
                        ? screensStatus[ScreenCode].player_version
                        : null;

                    // console.log("screensStatus[ScreenCode] " + JSON.stringify(screensStatus))

                    // if (!firebase.isOnline)
                    //     return null
                    // else
                    return isPaired === 1 ? (
                      <Tag
                        closable
                        onClose={(event) => {
                          onNeedsUnpair(record);
                          event.preventDefault();
                        }}
                      >
                        <Space>
                          <LinkOutlined />
                          {`${os} (${osVersion}) ${playerVersion ? ` [player v.${playerVersion}]` : ""}`}
                        </Space>
                      </Tag>
                    ) : (
                      <Button
                        icon={<DisconnectOutlined />}
                        disabled={!createPermission}
                        onClick={() => {
                          onPairScreen(record);
                        }}
                        shape="round"
                        type="link"
                      >
                        N/A
                      </Button>
                    );
                  }}
                />

                <Column
                  align="center"
                  width="200px"
                  style={{ width: "50px" }}
                  title="Actions"
                  dataIndex="actions"
                  key="actions"
                  render={(screenNum, record, index) => {
                    const isOnline =
                      "is_online" in screensStatus[record.ScreenCode]
                        ? screensStatus[record.ScreenCode].is_online
                        : 0;
                    const isPlaying =
                      "is_playing" in screensStatus[record.ScreenCode]
                        ? screensStatus[record.ScreenCode].is_playing
                        : 0;

                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Popover
                          content={
                            <div style={{ width: 180, padding: "8px" }}>
                              <Row
                                justify="space-between"
                                align="middle"
                                style={{ marginBottom: 8, width: "100%" }}
                              >
                                <Col span={13}>
                                  <Slider
                                    min={0}
                                    max={1}
                                    step={0.01}
                                    value={
                                      tempFormatValues[record.ScreenCode] ??
                                      formatValues[record.ScreenCode] ??
                                      1
                                    }
                                    onChange={(val) =>
                                      setTempFormatValues((prev) => ({
                                        ...prev,
                                        [record.ScreenCode]: val,
                                      }))
                                    }
                                    tooltip={{
                                      formatter: (value) =>
                                        `${Math.round(value * 100)}%`,
                                    }}
                                  />
                                </Col>
                                <Col span={8}>
                                  <InputNumber
                                    min={0}
                                    max={1}
                                    style={{
                                      width: "100%",
                                      // margin: '0 16px',
                                    }}
                                    value={
                                      tempFormatValues[record.ScreenCode] ??
                                      formatValues[record.ScreenCode] ??
                                      1
                                    }
                                    onChange={(val) => {
                                      setTempFormatValues((prev) => ({
                                        ...prev,
                                        [record.ScreenCode]: val,
                                      }));
                                    }}
                                  />
                                </Col>
                              </Row>
                              <div style={{ marginTop: 8, textAlign: "right" }}>
                                <Button
                                  type="primary"
                                  size="small"
                                  onClick={() => {
                                    const newVal =
                                      tempFormatValues[record.ScreenCode] ??
                                      formatValues[record.ScreenCode] ??
                                      1;
                                    // update main state
                                    setFormatValues((prev) => ({
                                      ...prev,
                                      [record.ScreenCode]: newVal,
                                    }));

                                    // update firebase
                                    try {
                                      if (firebase && firebase.database) {
                                        const {
                                          AccountCode,
                                          BrandCode,
                                          BranchCode,
                                          ScreenCode,
                                        } = record;
                                        const formatDB = firebase
                                          .database()
                                          .ref(
                                            `${AccountCode}/${BrandCode}/${BranchCode}`,
                                          );
                                        formatDB
                                          .child(ScreenCode)
                                          .update({ saturation: newVal });
                                      }
                                    } catch (error) {
                                      console.warn(
                                        "Firebase update failed:",
                                        error,
                                      );
                                    }

                                    message.success(
                                      "Saturation updated successfully",
                                    );
                                    // close popover
                                    toggleFormatPopover(null);
                                  }}
                                >
                                  Save
                                </Button>
                              </div>
                            </div>
                          }
                          title="Saturation (Requires v1.0.7+)"
                          trigger="click"
                          placement="top"
                          open={formatPopoverVisible === record.ScreenCode}
                          onOpenChange={() =>
                            toggleFormatPopover(record.ScreenCode)
                          }
                          overlayStyle={{ zIndex: 2000 }}
                        >
                          <Tooltip title="Adjust Saturation">
                            <Button
                              type="text"
                              style={{
                                width: "32px",
                                height: "32px",
                                padding: "4px",
                              }}
                            >
                              <FormatPainterFilled
                                style={{
                                  marginTop: "6px",
                                  color: "#1890ff",
                                  fontSize: 16,
                                  filter: `saturate(${tempFormatValues[record.ScreenCode] ?? 1})`,
                                }}
                              />
                            </Button>
                          </Tooltip>
                        </Popover>

                        <ActionButton
                          visible={editBrightness}
                          onClicked={() => onEditBrightness(record)}
                          title="Brightness Manager"
                          showTitle={false}
                          icon="/cms/assets/svgs/icons/brightness_icon.svg"
                        />

                        <ButtonGroup
                          placement="top"
                          vertical={true}
                          title="Player Controls"
                          disabled={!isOnline}
                          items={[
                            <Button
                              disabled={false}
                              id="capture_screen"
                              onClick={(e) =>
                                onPreRemoteAction(record, "capture_screen")
                              }
                              type="secondary"
                              title="Capture Screen"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_player_screencapture.svg"
                                  style={{
                                    width: "16px",
                                    pointerEvents: "none",
                                    height: "auto",
                                    opacity: 1,
                                    marginRight: "8px",
                                  }}
                                ></img>
                              }
                            >
                              Capture Screen
                            </Button>,
                            isPlaying === 1 ? (
                              <Button
                                disabled={false}
                                id="toggle_play"
                                onClick={(e) =>
                                  onPreRemoteAction(record, "toggle_play")
                                }
                                type="secondary"
                                title="Toggle Play"
                                icon={
                                  <img
                                    src="/cms/assets/svgs/icons/remote_tools/remote_player_stop.svg"
                                    style={{
                                      width: "16px",
                                      pointerEvents: "none",
                                      height: "auto",
                                      opacity: 1,
                                      marginRight: "8px",
                                    }}
                                  ></img>
                                }
                              >
                                Stop/Play
                              </Button>
                            ) : (
                              <Button
                                disabled={false}
                                id="toggle_play"
                                onClick={(e) =>
                                  onPreRemoteAction(record, "toggle_play")
                                }
                                type="secondary"
                                title="Toggle Play"
                                icon={
                                  <img
                                    src="/cms/assets/svgs/icons/remote_tools/remote_player_play.svg"
                                    style={{
                                      width: "16px",
                                      pointerEvents: "none",
                                      height: "auto",
                                      opacity: 1,
                                      marginRight: "8px",
                                    }}
                                  ></img>
                                }
                              >
                                Stop/Play
                              </Button>
                            ),
                            <Button
                              disabled={false}
                              id="reload_player"
                              onClick={(e) =>
                                onPreRemoteAction(record, "reload_player")
                              }
                              type="secondary"
                              title="Reload Player"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_player_reload.svg"
                                  style={{
                                    width: "16px",
                                    pointerEvents: "none",
                                    height: "auto",
                                    opacity: 1,
                                    marginRight: "8px",
                                  }}
                                ></img>
                              }
                            >
                              Reload Player
                            </Button>,
                          ]}
                        >
                          <Tooltip title={isOnline ? "" : "Player Controller"}>
                            <Button
                              disabled={false}
                              type="text"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_player.svg"
                                  style={{
                                    width: "18px",
                                    height: "auto",
                                    opacity: isOnline ? 1 : 0.3,
                                  }}
                                ></img>
                              }
                            ></Button>
                          </Tooltip>
                        </ButtonGroup>
                        <ButtonGroup
                          placement="top"
                          vertical={true}
                          title="Hardware Controls"
                          disabled={!isOnline}
                          items={[
                            <Button
                              disabled={false}
                              id="reboot_hardware"
                              onClick={(e) =>
                                onPreRemoteAction(record, "reboot_hardware")
                              }
                              type="secondary"
                              title="Reboot Hardware"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_hardware_reboot.svg"
                                  style={{
                                    width: "16px",
                                    pointerEvents: "none",
                                    height: "auto",
                                    opacity: 1,
                                    marginRight: "8px",
                                  }}
                                ></img>
                              }
                            >
                              Reboot Hardware
                            </Button>,
                            <Button
                              disabled={false}
                              id="shutdown_hardware"
                              onClick={(e) =>
                                onPreRemoteAction(record, "shutdown_hardware")
                              }
                              type="secondary"
                              title="Shutdown Hardware"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_hardware_shutdown.svg"
                                  style={{
                                    width: "16px",
                                    pointerEvents: "none",
                                    height: "auto",
                                    opacity: 1,
                                    marginRight: "8px",
                                  }}
                                ></img>
                              }
                            >
                              Shutdown Hardware
                            </Button>,
                          ]}
                        >
                          <Tooltip
                            title={isOnline ? "" : "Hardware Controller"}
                          >
                            <Button
                              disabled={false}
                              type="text"
                              icon={
                                <img
                                  src="/cms/assets/svgs/icons/remote_tools/remote_hardware.svg"
                                  style={{
                                    width: "18px",
                                    height: "auto",
                                    opacity: isOnline ? 1 : 0.3,
                                  }}
                                ></img>
                              }
                            ></Button>
                          </Tooltip>
                        </ButtonGroup>
                        <ActionButton
                          visible={editPermission}
                          onClicked={() => onEdit(record)}
                          title={t.edit}
                          showTitle={false}
                          icon="/cms/assets/svgs/icons/edit_icon.svg"
                        ></ActionButton>
                        <ActionButton
                          visible={deletePermission}
                          confirmText={t.deleteConfirm}
                          onClicked={() => onDelete(record)}
                          title={t.delete}
                          showTitle={false}
                          icon="/cms/assets/svgs/icons/trash_icon.svg"
                        ></ActionButton>
                      </div>
                    );
                  }}
                />
                {allowPublishPermission ? (
                  <Column
                    width="180px"
                    align="center"
                    style={{
                      width: "50px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    title=""
                    dataIndex="CampaignID"
                    key="CampaignID"
                    render={(campaignID, record, index) => {
                      const isOnline =
                        "is_online" in screensStatus[record.ScreenCode]
                          ? screensStatus[record.ScreenCode].is_online
                          : 0;
                      const licenseActive = !CHECK_LICENSE
                        ? true
                        : "LicenseStatus" in record
                          ? record.LicenseStatus == "active"
                          : false;

                      if (!licenseActive) {
                        return (
                          <div
                            style={{
                              pointerEvents: "auto",
                              display: "inline-block",
                            }}
                          >
                            <Tooltip title="Go to Manage License Page">
                              <Button
                                onClick={() => {
                                  selectPage(Constants.LICENSE_PAGE);
                                }}
                                className="btn-purple"
                                type="dashed"
                              >
                                Manage License
                              </Button>
                            </Tooltip>
                          </div>
                        );
                      }

                      if (!campaignID || campaignID === "") {
                        return (
                          <div style={{ display: "inline-block" }}>
                            <Tooltip title="Click edit to link your screen to a campaign before publish">
                              <Button disabled title="Publish" type="primary">
                                Publish
                              </Button>
                            </Tooltip>
                          </div>
                        );
                      } else if (!isOnline) {
                        return (
                          <Button.Group>
                            <Popconfirm
                              title="Publish content to this screen once it's online?"
                              onConfirm={() => onPublish(record)}
                              okText="Yes"
                              cancelText="No"
                            >
                              <Button type="primary" title="Publish">
                                Publish
                              </Button>
                            </Popconfirm>
                            <Button
                              icon={<ClockCircleOutlined />}
                              onClick={() =>
                                setOpenPopoverCode(record?.ScreenCode)
                              }
                            />
                          </Button.Group>
                        );
                      }
                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <Popconfirm
                            title="Instantly publish content to this screen?"
                            onConfirm={() => onPublish(record)}
                            okText="Yes"
                            cancelText="No"
                          >
                            <Button type="primary" title="Publish">
                              Publish
                            </Button>
                          </Popconfirm>
                          <Button
                            icon={<ClockCircleOutlined />}
                            onClick={() =>
                              setOpenPopoverCode(record?.ScreenCode)
                            }
                          />
                        </div>
                      );
                    }}
                  />
                ) : null}
              </>
            );
          }}
        </AbstractTableView>
      )}
      <Modal
        destroyOnClose
        width={800}
        open={publishingHistoryVisible}
        onCancel={() => setPublishingHistoryVisible(false)}
        footer={null}
      >
        <ScreenPublishingHistoryView
          screendata={publishingHistoryScreenData}
          onClose={() => setPublishingHistoryVisible(false)}
        ></ScreenPublishingHistoryView>
      </Modal>
    </>
  );
};

export default ScreenTableView;
